{
  "MALE": "Male",
  "FEMALE": "Female",
  "GEL": "GEL",
  "NAV": {
    "APPLICATIONS": "Menu",
    "DASHBOARDS": "Main",
    "user-sources": "User Sources",
    "CASHIER": "Cashier",
    "EXPENCE": "Expence",
    "add_expences": "processing exit",
    "administration": "Administration",
    "organizations": "Organizations",
    "HR": "HR",
    "users": "Employees",
    "salary": "Salaries",
    "scheduleOverview": "Schedule overview",
    "services": "Procedures",
    "customers": "Users",
    "customer_duplicates": "Duplicate numbers",
    "calendars": "Calendar",
    "calendars_daily": "day form",
    "calendars_daily_new": "Day form(new)",
    "calendars_room": "Day form(rooms)",
    "calendars_canceled": "records",
    "online_booking": "Online Booking",
    "stats": "Statistics",
    "stats_detailed": "detailed search",
    "profit_loss": "profit-loss",
    "graphs": "graphic charts",
    "transactions": "Transactions",
    "transaction_history": "History",
    "transaction_deleted": "Deleted",
    "communication": "Communication",
    "communication_sms": "Communication",
    "communication_history": "message history",
    "operations": "operations",
    "consignations": "consignments",
    "expense_categories": "Exit categories",
    "visitReminder": "Visit reminder",
    "USER_STATUS": "User Statuses",
    "USER_Loyalty": "Loyalty System",
    "offers": "Offers",
    "packages": "Packages",
    "terms": "Verification",
    "questionary-builder": "EHR Questionnaires",
    "ehr": "EHR",
    "erx": "eRX",
    "organization": "Organization",
    "agreement-templates": "Agreement templates",
    "classification_codes": "Classification codes",
    "patients": "Patients",
    "invoices": "Invoices",
    "rooms": "Rooms",
    "booking-sources": "Booking Sources",
    "reports": "Reports",
    "cash_flow": "Cash Flow",
    "employee_income": "Employee Income",
    "service_analytics": "Service Analytics",
    "category_analytics": "Category Analytics",
    "client_spending": "Client Spending",
    "bookinghub": "BookingHub",
    "onlineCatalog": "Online Catalog",
    "ehrTemplate": "EHR Templates",
    "service_packages": "Service Packages",
    "communication_config": "SMS configuration",
    "birthdayGreetings": "Birthdays",
    "birthdayConfig": "Birthday configuration",
    "productions": "Products",
    "products": " Full list",
    "realizations": "Realization"
  },
  "COLUMNS": {
    "transactionId": "Trans. #",
    "name": "Name",
    "branch": "Branch",
    "legalForm": "Legal Form",
    "legalName": "Legal Name",
    "registrationNumber": "Registration Number",
    "physicalAddress": "fact. dress.",
    "legalAddress": "Legal Adres",
    "director": "Director",
    "identityNumber": "Identification#",
    "mobilePhone": "Phone number",
    "phone": "Phone",
    "facebook": "facebook",
    "information": "Information",
    "createdAt": "Created",
    "cardNo": "Card #",
    "selectUser": "Change customer",
    "updateUser": "Update customer",
    "unknownUser": "Unknown customer",
    "firstname": "Name",
    "lastname": "Lastname",
    "fullName": "Name, Last Name",
    "gender": "Gender",
    "birthDate": "Birthday",
    "position": "Position",
    "productCategory": "Product Category",
    "serviceCategory": "Service Category",
    "distributor": "Distributor",
    "quantity": "Quantity",
    "sum": "Sum",
    "grSum": "Gram sum",
    "grPerItem": "Gram Per Item",
    "pricePerItem": "buy price",
    "avgPricePerItem": "sell price (AVG)",
    "salePricePerItem": "Sale Price",
    "buyDate": "Buy Date",
    "updateDate": "Update Date",
    "transactionType": "Transaction Type",
    "employee": "Employee",
    "user": "User",
    "service": "Service",
    "priceSum": "paid",
    "cash": "Casah",
    "card": "Card",
    "price": "Price",
    "bookingDate": "Booking Date",
    "startTime": "Start Time",
    "endTime": "End Time",
    "salePrice": "Sale Price",
    "salePercent": "Sale % ",
    "fixedPrice": "Fixed Price",
    "fixedPercent": "Fixed %",
    "fixedSpend": "Fixed Spend",
    "additionalExpense": "Additional Expense",
    "barcode": "Barcode",
    "productName": "Product Name",
    "productVolume": "Product Volume",
    "peymentType": "Type of payment",
    "createdBy": "Created By",
    "status": "Status",
    "unitGram": "Volume",
    "unitQuantity": "Quantity",
    "minutes": "Minutes",
    "balance": "Balance (₾)",
    "employeePercent": "Employee %",
    "employeeSalary": "Salary",
    "employeFixedPrice": "Fixed Price",
    "specFixedSpend": "cost of spec.procedure",
    "time": "Time",
    "isSpecial": "Special",
    "autoPriceView": "price automatically",
    "autoTimeView": "time automatically",
    "color": "Color",
    "category": "Category",
    "room": "Room",
    "whStart": "Start Time",
    "whEnd": "End Time",
    "description": "Description",
    "comment": "Comment",
    "expenceCategory": "category of expences",
    "username": "User",
    "date": "Date",
    "openSum": "While opening",
    "addMoney": "Added",
    "income": "Income",
    "incomeCash": "Cash income",
    "incomeCard": "Non-cash income",
    "outcome": "Outcome",
    "outcomeCash": "Cash outcome",
    "outcomeCard": "Non-cash outcome",
    "expense": "Fixed expense",
    "closeSum": "While closing",
    "salarySum": "Salaries",
    "expenceSum": "Other expenses",
    "profit": "Profit",
    "profit_expense": "Profit - Fixed expense",
    "insurance": "Provider",
    "contactPerson": "Contact person",
    "contactPhone": "Contact phone",
    "contactMobile": "Contact mobile",
    "OperationNumber": "#",
    "operationType": "Type",
    "operationSource": "Source of operation",
    "operationDate": "Date",
    "bestBefore": "Valid until",
    "avgPrice": "Average price",
    "isSpend": "Recorded as expense",
    "senderName": "Sender",
    "to": "To",
    "eventType": "SMS type",
    "eventKey": "Event source",
    "schedulePeriod": "Schedule period",
    "messageTemplate": "Message template",
    "role": "Role",
    "bankTransfer": "Bank transfer",
    "icdCode": "ICD Code",
    "ehrId": "EHR ID",
    "hospitalizationResult": "Hospitalization Result",
    "deletedAt": "Deleted At",
    "deletedBy": "Deleted By",
    "disabledAt": "Disabled At",
    "disabledBy": "Disabled By",
    "disableReason": "Disable Reason",
    "productCode": "Product Code",
    "provider": "Provider",
    "providerPrice": "Provider Price",
    "expenceMainCategory": "Expense category",
    "canSchedule": "Can Schedule Online"
  },
  "PAYMENTTYPE": {
    "1": "Pay with cash",
    "2": "Bank card",
    "3": "Cash+bank",
    "4": "minutes",
    "5": "balance",
    "6": "barter",
    "7": "Consignment",
    "8": "Bank transfer",
    "9": "Mixed payment",
    "10": "Card",
    "11": "No payment",
    "12": "Online (BookingHub)"
  },
  "TRANSACTIONTYPE": {
    "SELL": "sell",
    "SPEND": "expand",
    "EVENT": "appointment",
    "SALARY": "salary",
    "REALIZATION": "realisation",
    "EXPENCE": "expence",
    "BUY": "purchase",
    "BALANCEIN": "Balance Add",
    "BALANCEOUT": "Balance return",
    "BALANCERETURN": "Balance return",
    "CONSIGNATION": "Consignment",
    "CASHIER": "Cashier add",
    "CASHIER_OUT": "Cashier out"
  },
  "OPERATION_TYPE": {
    "SELL": "Sell",
    "SPEND": "Expand",
    "EVENT": "Appointment",
    "EVENT_SPEC": "Special procedure",
    "SALARY": "Salary Payment",
    "SALARY_OUT": "Salary",
    "REALIZATION": "Realisation",
    "EXPENCE": "Expence",
    "BUY": "Purchase",
    "BALANCEIN": "Fill the balance",
    "BALANCEOUT": "Balance return",
    "BALANCERETURN": "Balance return",
    "CASHIER_ADD": "Cashier add",
    "CASHIER_OUT": "Cashier out",
    "CONSIGNATION_PAY": "Consignment pay",
    "PACKAGE_ITEM": "Package service"
  },
  "OPERATION_SOURCE": {
    "NONE": "N/A",
    "BOOKING": "Booking",
    "SALARY": "Salary",
    "REALIZATION": "Realization",
    "EXPENCE": "Expense",
    "BUY": "Purchase",
    "PURCHASE": "Purchase",
    "BALANCEIN": "Balance Top-up",
    "BALANCE": "Balance Top-up",
    "BALANCERETURN": "Balance Return",
    "CASHIER": "Cashier",
    "SERVICE_PACKAGE": "Service Package"
  },
  "operation": {
    "detailsByBank": "Details by bank",
    "noBankInfo": "No per-bank information",
    "editComment": "Edit comment",
    "commentHistory": "Comment history",
    "noCommentEdits": "No edits yet",
    "editedBy": "Edited by {{name}}",
    "editCommentFailed": "Failed to save comment"
  },
  "PAGINATION": {
    "page": "Page",
    "pageCount": "Sum"
  },
  "CASHIER": {
    "date": "The date",
    "yesNo": "Are you sure you want to close the day?",
    "start": "Start",
    "finish": "Finish",
    "update": "The update",
    "addCash": "Add the amount",
    "edit": "Edit",
    "addSum": " The amount",
    "page": "Page",
    "comment": "Comment",
    "openingDay": "Opening of the day",
    "reOpen": "Re-open",
    "reOpenConfirm": "Are you sure you want to re-open the day?",
    "need_open": "You need to open the day",
    "operationType": "Operation type",
    "statistic": {
      "edit": "Cash register opening change",
      "addCash": "Add the amount",
      "openSum": "Sum at a day opening",
      "close": "Closing of cash register",
      "open": "Opening of cash register",
      "income": "Income",
      "expense": "Fixed Expense",
      "additionalExpense": "Additional Expense",
      "outcome": "Expenses",
      "currentSum": "Current amount",
      "payoutCash": "Cash Withdrawal"
    },
    "COLUMNS": {
      "date": "The date",
      "openSum": "While opening",
      "addMoney": "Added",
      "income": "Income",
      "incomeCash": "Cash",
      "incomeCard": "Card",
      "incomeBank": "Bank",
      "outcome": "Expenses",
      "outcomeBank": "Exp. Bank",
      "outcomeCash": "Exp. Cash",
      "outcomeCard": "Exp. Card",
      "expense": "Product expense",
      "additionalExpense": "Additional expense",
      "closeSum": "While closing",
      "createdBy": "Opened by",
      "comment": "Comment",
      "openedAt": "Opening date",
      "closedAt": "Closing date",
      "closedBy": "Closed by"
    },
    "advanced": {
      "currentTab": "Current cashier",
      "historyTab": "Past cashiers",
      "transactions": "Transactions",
      "noBank": "No bank",
      "refresh": "Refresh",
      "export": "Export",
      "retry": "Retry",
      "loadFailed": "Could not load the data",
      "exportFailed": "Export failed",
      "reopen": "Reopen",
      "reopenConfirm": "Are you sure you want to reopen this cashier day?",
      "clearFilter": "Clear filter",
      "time": "Time",
      "type": "Type",
      "method": "Payment method",
      "bank": "Bank",
      "amount": "Amount",
      "total": "Total",
      "date": "Date",
      "cash": "Cash",
      "card": "Card",
      "cashInDrawer": "Cash in drawer",
      "addMoney": "Add money",
      "subMoney": "Withdraw money",
      "closeDay": "Close day",
      "bankTransfer": "Bank transfer",
      "openedAt": "Opened at",
      "openedBy": "Opened by",
      "tour": {
        "next": "Next",
        "prev": "Back",
        "done": "Done",
        "progress": "{{current}} / {{total}}",
        "tabsTitle": "Two tabs",
        "tabsBody": "\"Current cashier\" is today's till. \"Past cashier days\" is the history of closed days.",
        "daySummaryTitle": "Day summary",
        "daySummaryBody": "One card shows the state of the till: balance, income and expenses.",
        "actionsTitle": "Quick actions",
        "actionsBody": "Add money, withdraw money and more. Hover an icon to see its name.",
        "dayStateTitle": "Open and close the day",
        "dayStateBody": "Open or close the cashier day with this button.",
        "banksTitle": "By bank",
        "banksBody": "Click a bank to show only that bank's transactions below.",
        "bannerTitle": "Version switch",
        "bannerBody": "Until 26 October you can switch back to the old version here, or replay this tour.",
        "learnMore": "Detailed walkthrough",
        "sectionHelpTitle": "Detailed walkthroughs",
        "sectionHelpBody": "Each section has a ? button. Click it for a detailed walkthrough of that part: the cards, actions, transactions and closed days.",
        "sections": {
          "summary": {
            "openCardTitle": "Opening balance",
            "openCardBody": "The cash in the till when the day was opened.",
            "openMovesTitle": "Added and withdrawn",
            "openMovesBody": "Green is money added during the day, red is money withdrawn. On the right is the cashier day's date.",
            "openedByTitle": "Opened by",
            "openedByBody": "When the day was opened and which employee opened it.",
            "incomeCardTitle": "Income",
            "incomeCardBody": "The day's total income across all payment methods.",
            "incomeMethodsTitle": "Payment methods",
            "incomeMethodsBody": "Income split into cash, card and bank transfer. Under card and transfer you see how much came through each bank.",
            "incomeExpensesTitle": "Expenses",
            "incomeExpensesBody": "Product expense, additional expense and their total.",
            "incomeBanksTitle": "Income by bank",
            "incomeBanksBody": "Card and transfer income per bank. Click a bank to show only its transactions below.",
            "outcomeCardTitle": "Outcome",
            "outcomeCardBody": "The day's total outcome.",
            "outcomeMethodsTitle": "Outcome methods",
            "outcomeMethodsBody": "Outcome split into cash, card and bank transfer, with the per-bank amounts under card and transfer.",
            "outcomeBanksTitle": "Outcome by bank",
            "outcomeBanksBody": "Click a bank to show only that bank's transactions below.",
            "currentCardTitle": "Current balance",
            "currentCardBody": "The cash that should be in the till right now."
          },
          "actions": {
            "addTitle": "Add money",
            "addBody": "Put cash into the till, for example for change.",
            "subTitle": "Withdraw money",
            "subBody": "Take cash out of the till.",
            "editOpenTitle": "Edit opening balance",
            "editOpenBody": "Correct the day's opening balance if it was entered wrong.",
            "refreshTitle": "Refresh",
            "refreshBody": "Reload the cashier data.",
            "dayStateTitle": "Open and close the day",
            "dayStateBody": "Open the till at the start of the day and close it at the end. A day you just closed can be reopened here too."
          },
          "transactions": {
            "filtersTitle": "Filters",
            "filtersBody": "Filter transactions by type, payment method and bank.",
            "refreshTitle": "Refresh",
            "refreshBody": "Reload the transaction list.",
            "exportTitle": "Export",
            "exportBody": "Download the transactions as an Excel file.",
            "colTimeTitle": "Time",
            "colTimeBody": "When the transaction happened.",
            "colKindTitle": "Type and method",
            "colKindBody": "What the operation is (e.g. visit payment, money added) and how it was paid.",
            "colBankTitle": "How it was paid",
            "colBankBody": "The total split by payment method: cash, card and bank transfer. Card and transfer amounts show their bank next to them; cash has no bank.",
            "colAmountTitle": "Total",
            "colAmountBody": "The full transaction amount — cash, card and bank transfer added together."
          },
          "history": {
            "rangeTitle": "Period",
            "rangeBody": "Pick dates to see the closed days in that period.",
            "refreshTitle": "Refresh",
            "refreshBody": "Reload the list.",
            "exportTitle": "Export",
            "exportBody": "Download the closed days as an Excel file.",
            "colDateTitle": "Date",
            "colDateBody": "The cashier day.",
            "colOpenTitle": "Opening balance and movements",
            "colOpenBody": "The day's opening balance and money added or withdrawn during the day.",
            "colIncomeTitle": "Income",
            "colIncomeBody": "Total income and its split: cash, card, transfer. The card and transfer columns also list the amounts per bank.",
            "colOutcomeTitle": "Outcome",
            "colOutcomeBody": "Total outcome and its split: cash, card, transfer, per bank.",
            "colExpenseTitle": "Expenses",
            "colExpenseBody": "Product expense and additional expense.",
            "colCloseTitle": "Closing balance",
            "colCloseBody": "The cash left in the till when the day was closed.",
            "colPeopleTitle": "Opened and closed",
            "colPeopleBody": "When and by whom the till was opened and closed.",
            "colCommentTitle": "Comment",
            "colCommentBody": "The comment left when the day was closed.",
            "rowActionsTitle": "Actions",
            "rowActionsBody": "Update recalculates the day's sums. Edit corrects the opening balance."
          }
        }
      }
    },
    "versionSwitch": {
      "oldBanner": "The updated cashier is available. Until 26 October you can try it and switch back to the old version if you prefer.",
      "newBanner": "You are using the updated cashier. Until 26 October you can switch back to the old version; after that date only the new version remains.",
      "tryNew": "Switch to the new version",
      "backToOld": "Back to the old version",
      "tour": "Guided tour",
      "confirmToNewTitle": "Switch to the new cashier?",
      "confirmToOldTitle": "Go back to the old cashier?",
      "confirmBody": "This applies to every employee of the branch. No cashier data changes.",
      "failed": "Could not change the version. Please try again."
    }
  },
  "HR": {
    "employee": {
      "positions": "Positions",
      "employees": "Employees"
    }
  },
  "PAYROLL": {
    "title": "Payroll",
    "periods": "Payroll periods",
    "year": "Year",
    "period": "Period",
    "status": "Status",
    "total": "Total",
    "open": "Open",
    "calculate": "Calculate",
    "recalculate": "Recalculate",
    "generateYear": "Generate {{year}}",
    "generated": "Periods generated",
    "back": "Back to periods",
    "employees": "{{count}} employees",
    "finalSalary": "Final salary",
    "formerEmployee": "Former employee",
    "noLines": "This run produced no lines.",
    "noPeriodsTitle": "No payroll periods for {{year}}",
    "noPeriodsHint": "Generate them from your configured cycle.",
    "retry": "Retry",
    "state": {
      "calculated": "Calculated",
      "approved": "Approved",
      "ended": "Not calculated",
      "inProgress": "In progress",
      "upcoming": "Upcoming"
    },
    "kind": {
      "FIXED": "Fixed",
      "COMMISSION": "Commission",
      "ADJUSTMENT": "Adjustment",
      "CORRECTION": "Correction"
    },
    "recalcConfirm": {
      "title": "Recalculate this period?",
      "body": "The current figures will be deleted and replaced.",
      "ok": "Recalculate",
      "cancel": "Cancel"
    },
    "skipped": {
      "warning": "{{count}} employees were skipped",
      "review": "Review",
      "title": "Skipped employees",
      "setRate": "Set pay rate",
      "reason": {
        "NO_RATE_SLICE": "No pay rate set up",
        "NOT_EMPLOYED_IN_PERIOD": "Not employed during this period"
      }
    },
    "rate": {
      "title": "Set pay rate",
      "fixedSalary": "Fixed salary (per month)",
      "outputPercent": "Commission (% of output)",
      "effectiveFrom": "Effective from",
      "save": "Save",
      "cancel": "Cancel",
      "saved": "Pay rate saved",
      "recalculateNow": "Recalculate now",
      "current": "Current rate: {{fixed}} + {{percent}}%",
      "none": "No pay rate on file",
      "history": {
        "title": "Rate history",
        "current": "Current",
        "previous": "Previous",
        "openEnded": "from {{from}}",
        "closed": "{{from}} → {{to}}",
        "none": "No earlier rates on file"
      }
    },
    "errors": {
      "notEnabled": "Payroll isn't enabled for this branch yet.",
      "forbidden": "You don't have permission to do that.",
      "futurePeriod": "This period hasn't started yet.",
      "runConflict": "Someone else is calculating this period. Try again in a moment.",
      "runNotFound": "This payroll run no longer exists.",
      "periodNotFound": "This payroll period no longer exists.",
      "periodBranchMismatch": "This period belongs to a different branch.",
      "rateBackdate": "That date is before the current pay rate started. Pick a later date.",
      "rateTerminateBeforeStart": "The end date is before the current pay rate started.",
      "rateNegative": "Salary and commission can't be negative.",
      "rateRangeInverted": "The end date is before the start date.",
      "carryForwardSystemOnly": "Carried-forward entries are created by the system and can't be added by hand.",
      "recurUntilNotAllowed": "Only a recurring bonus can have an end date.",
      "recurUntilBackward": "The end date must be later than the current one.",
      "foreignEmployee": "That employee isn't in your organization.",
      "adjustmentNotFound": "This adjustment no longer exists.",
      "equalSplitWeekly": "Equal split can't be used with a weekly cycle.",
      "rangeInverted": "The start date is after the end date.",
      "runAlreadyApproved": "This run is already approved.",
      "runNotApproved": "This run is not approved.",
      "runHasPayouts": "Payments have already been recorded against this run. Void them first to un-approve it.",
      "nextPeriodMissing": "Someone owes money back and there is no next period to carry it into. Generate the next period first.",
      "carryForwardConsumed": "A later run has already used this run's carry-forward, so it can no longer be un-approved.",
      "employeeNotInRun": "That employee is not part of this run.",
      "lineNotFound": "That payroll line no longer exists. Reload the run.",
      "payoutExceedsBalance": "That is more than this person is still owed.",
      "payoutZero": "Enter an amount.",
      "payoutNotFound": "That payment no longer exists.",
      "runBranchMismatch": "This run belongs to a different branch.",
      "bankIdRequired": "Choose a bank for the transfer.",
      "bankIdNotAllowedForCash": "Cash has no bank.",
      "duplicateTenderMethod": "Each payment method can be entered only once per person.",
      "generic": "Something went wrong. Please try again."
    },
    "pay": {
      "approve": "Approve",
      "unapprove": "Un-approve",
      "approveAndPay": "Approve and pay",
      "recordPayment": "Record payment",
      "approvedOn": "Approved {{date}}",
      "paid": "paid {{amount}}",
      "remaining": "remaining {{amount}}",
      "owed": "owed {{amount}}",
      "settled": "settled",
      "nothingToPay": "Nothing to pay",
      "date": "Date",
      "cash": "Cash",
      "bank": "Bank",
      "addBank": "Add bank",
      "removeLeg": "Remove",
      "chooseBank": "Bank",
      "summary": "{{count}} people · {{amount}}",
      "submit": "Pay",
      "cancel": "Cancel",
      "noPayouts": "No payments recorded yet.",
      "history": "Payments",
      "void": "Remove payment",
      "approveConfirm": {
        "title": "Approve this run?",
        "body": "The figures are frozen after this and can no longer be recalculated. You can un-approve while no payment has been recorded.",
        "ok": "Approve",
        "cancel": "Cancel"
      },
      "unapproveConfirm": {
        "title": "Un-approve this run?",
        "body": "The run goes back to being recalculable.",
        "ok": "Un-approve",
        "cancel": "Cancel"
      },
      "voidConfirm": {
        "title": "Remove this payment?",
        "body": "The {{amount}} goes back to {{name}}'s remaining balance and the cashbox entry is reversed.",
        "ok": "Remove",
        "cancel": "Cancel"
      },
      "approved": "Run approved.",
      "unapproved": "Run un-approved.",
      "recorded": "Payment recorded.",
      "voided": "Payment removed.",
      "total": "Run total",
      "paidLabel": "Paid",
      "remainingLabel": "Outstanding",
      "payMany": "Pay several",
      "exitBatch": "Done selecting",
      "colName": "Employee",
      "colOwed": "Earned",
      "colPaid": "Paid",
      "colRemaining": "Outstanding",
      "partial": "part paid",
      "due": "to pay",
      "nothingToPayGroup": "{{count}} with nothing to pay this period",
      "countDue": "{{count}} to pay",
      "countDone": "{{count}} done",
      "colPayment": "Payment",
      "people": "{{count}} people",
      "payThis": "Pay…"
    },
    "nav": {
      "periods": "Periods",
      "adjustments": "Adjustments",
      "report": "Output",
      "settings": "Settings",
      "audit": "History"
    },
    "adjust": {
      "title": "Adjustments",
      "add": "Add adjustment",
      "none": "No adjustments match these filters",
      "filterEmployee": "Employee",
      "filterType": "Type",
      "allEmployees": "All employees",
      "allTypes": "All types",
      "systemGenerated": "Created by the system",
      "recurringSpan": "monthly, {{from}} → {{to}}",
      "recurringOpen": "monthly, from {{from}}",
      "unknownEmployee": "Unknown employee",
      "family": {
        "BONUS": "Bonus",
        "PENALTY": "Penalty",
        "CORRECTION": "Correction"
      },
      "kind": "Kind",
      "employee": "Employee",
      "amount": "Amount",
      "date": "Date",
      "reason": "Reason",
      "recurUntil": "Repeat until",
      "adds": "adds +{{amount}}",
      "deducts": "deducts −{{amount}}",
      "save": "Save",
      "cancel": "Cancel",
      "saved": "Adjustment saved",
      "type": {
        "BONUS_ONE_OFF": "Bonus",
        "BONUS_RECURRING": "Recurring bonus",
        "BONUS_KPI": "KPI bonus",
        "PENALTY_ABSENCE": "Penalty — absence",
        "PENALTY_LATENESS": "Penalty — lateness",
        "PENALTY_DAMAGE": "Penalty — damage",
        "CORRECTION_ADD": "Correction (add)",
        "CORRECTION_DEDUCT": "Correction (deduct)",
        "CARRY_FORWARD": "Carried forward"
      },
      "endRecurrence": {
        "action": "End recurrence",
        "title": "Stop this bonus after a date?",
        "body": "Payments already made stay. Nothing is paid after the date you choose.",
        "field": "Stop after",
        "ok": "Stop it",
        "cancel": "Cancel",
        "done": "Recurrence ended"
      },
      "revoke": {
        "action": "Remove",
        "title": "Remove this adjustment?",
        "body": "It is removed from every period that has not been paid, including past ones.",
        "ok": "Remove",
        "cancel": "Cancel",
        "done": "Adjustment removed"
      },
      "staleness": {
        "affectsRun": "A payroll run already covers {{date}}, and its figures no longer include this.",
        "openRun": "Open the run",
        "noPeriod": "No payroll period covers {{date}}, so this will not be paid until periods are generated."
      },
      "groupFamily": "Category",
      "groupType": "Type",
      "short": {
        "BONUS_ONE_OFF": "One-off",
        "BONUS_RECURRING": "Recurring",
        "BONUS_KPI": "KPI",
        "PENALTY_ABSENCE": "Absence",
        "PENALTY_LATENESS": "Lateness",
        "PENALTY_DAMAGE": "Damage",
        "CORRECTION_ADD": "Add",
        "CORRECTION_DEDUCT": "Deduct",
        "CARRY_FORWARD": "Carried forward"
      },
      "err": {
        "employee": "Choose an employee",
        "amount": "Enter an amount between 0.01 and 1,000,000",
        "date": "Choose a date",
        "reason": "Give a reason (max 500 characters)",
        "recurUntil": "The end date must be after the effective date"
      }
    },
    "settings": {
      "title": "Payroll settings",
      "editing": "Editing",
      "orgDefault": "Organization default",
      "thisBranch": "This branch",
      "orgDefaultLocked": "A branch override exists, so the organization default can't be read or edited here.",
      "cycle": "Cycle",
      "prorationBasis": "Proration basis",
      "splitDay": "Split day",
      "inheriting": "This branch is using the organization default.",
      "overridden": "This branch has its own settings.",
      "orgWarning": "This is the default for every branch with no override of its own.",
      "periodsWarning": "{{count}} periods already exist for {{year}}. Changing the cycle affects only periods generated from here on.",
      "confirmOrg": {
        "title": "Change the organization default?",
        "body": "This applies to every branch that has no settings of its own.",
        "ok": "Change it",
        "cancel": "Cancel"
      },
      "save": "Save",
      "saved": "Settings saved",
      "cycleValue": {
        "MONTHLY": "Monthly",
        "SEMI_MONTHLY": "Semi-monthly",
        "WEEKLY": "Weekly"
      },
      "basisValue": {
        "CYCLE_SHARE": "Cycle share",
        "SCHEDULED_DAYS": "Scheduled days",
        "EQUAL_SPLIT": "Equal split"
      },
      "equalSplitWeeklyHint": "Equal split can't be used with a weekly cycle."
    },
    "report": {
      "title": "Output by employee",
      "subtitle": "Gross output generated — before commission %, and excludes fixed salary, bonuses and penalties.",
      "from": "From",
      "to": "To",
      "employee": "Employee",
      "allEmployees": "All employees",
      "run": "Show",
      "transactions": "Transactions",
      "generatedOutput": "Generated output",
      "none": "No output recorded between these dates",
      "toPayroll": "For actual pay, open a payroll run"
    },
    "export": "Export",
    "exporting": "Exporting…",
    "audit": {
      "title": "History",
      "empty": "Nothing recorded yet.",
      "emptyFiltered": "No records match these filters.",
      "screenTitle": "Payroll history",
      "filterAction": "Action",
      "filterEmployee": "Employee",
      "filterFrom": "From",
      "filterTo": "To",
      "filterAll": "All",
      "reset": "Reset",
      "count": "{{count}} entries",
      "action": {
        "RUN_CALCULATE": "Calculated",
        "RUN_APPROVE": "Approved",
        "RUN_UNAPPROVE": "Un-approved",
        "PAYOUT_RECORD": "Paid",
        "PAYOUT_VOID": "Payment removed",
        "ADJUSTMENT_CREATE": "Adjustment added",
        "ADJUSTMENT_REVOKE": "Adjustment revoked",
        "RATE_SET": "Pay rate changed"
      }
    }
  },
  "SALARY": {
    "gel": "GEL",
    "wantContinue": "Are you sure you want to continue?",
    "COLUMN": {
      "employee": "Employee",
      "generatedCash": "Earned (GEL)",
      "generatedSale": "Products",
      "sum": "Sum (GEL)",
      "remainSalary": "To be issued",
      "salarySumOut": "Issued "
    },
    "comment": "Specify a comment",
    "createSalary": "Salary payment",
    "detailedSalary": "Salary by procedures",
    "salaryDate": "Salary date",
    "excelExport": "Excel export",
    "noExportData": "No data found for export",
    "totalLabel": "Total",
    "sumLabel": "Sum",
    "selectedCount": "Selected",
    "payDisabledForBranch": "This branch pays salaries from the Payroll screen.",
    "payFailed": "The salary could not be paid."
  },
  "SERVICE_PRODUCT": {
    "name": "Name",
    "price": "Selling Price",
    "time": "Time",
    "serviceCategory": "Category",
    "autoPriceView": "Auto Price",
    "autoTimeView": "Auto Time",
    "autoFix": "Auto Fixed Expense",
    "fixSum": "Fixed Expense",
    "products": "Products",
    "product": {
      "new_product": "New Product",
      "name": "Name",
      "gram": "Gram",
      "quantity": "Quantity",
      "pricePerItem": "Price per Item",
      "grPerItem": "Gram per Item",
      "expencePrice": "Expense Cost"
    },
    "notification": "Notification",
    "days": "Reminder Interval",
    "notificationMessage": "Reminder Message",
    "providers": "Providers",
    "provider": {
      "name": "Insurance",
      "productName": "Insurance Product",
      "price": "Insurance Price"
    }
  },
  "PRODUCT": {
    "barcode": "Barcode",
    "name": "Name",
    "code": "Product Code",
    "productCategory": "Category",
    "distributor": "Distributor",
    "pricePerItem": "Purchase Price",
    "salePricePerItem": "Selling Price",
    "grPerItem": "Gram per Item",
    "gram": "Gram",
    "quantity": "Quantity",
    "restGr": "Remaining (gram)",
    "buyDate": "Purchase Date",
    "bestBefore": "Best Before",
    "avgPrice": "Average Price",
    "isSpend": "Record as Expense",
    "comment": "Comment",
    "accountingDate": "Accounting Date"
  },
  "EVENT_TYPE": {
    "SYSTEM": "System",
    "SYSTEM_ADMIN": "System",
    "CUSTOM": "Custom"
  },
  "EVENT_KEY": {
    "COMPLETED": "After the visit",
    "BOOKING_UPDATE": "Booking changed",
    "BOOKED": "Booking confirmed",
    "BOOKING_REMINDER": "Visit reminder",
    "BOOKING_DELETED": "Booking cancelled",
    "PERIODIC_REMINDER": "Time to rebook",
    "ONLINE_BOOKING_INCOME": "Online booking",
    "ONLINE_BOOKING_CANCEL": "Online booking cancelled",
    "VERIFICATION_SMS": "Verification code",
    "OFFER_EXPIRY_WARNING": "Voucher expiring soon",
    "OFFER_PURCHASE_CONFIRMATION": "Voucher purchased",
    "OFFER_MERCHANT_NOTIFICATION": "Voucher sold",
    "PACKAGE_PURCHASE_CONFIRMATION": "Package purchased",
    "PACKAGE_USAGE": "Package service used",
    "PACKAGE_BATCH_USAGE": "Several services used",
    "PACKAGE_EXPIRED": "Package expired",
    "PACKAGE_EXPIRY_WARNING": "Package expiring soon",
    "INVOICE_GENERATED": "Invoice created",
    "EMPLOYEE_PASSWORD_RESET": "Staff password reset",
    "USER_PASSWORD_RESET": "User password reset"
  },
  "SCHEDULE_PERIOD_TYPE": {
    "NOW": "Immediately",
    "ONE_TIME": "One-time",
    "DAILY": "Daily",
    "Monthly": "Monthly",
    "Yerly": "Yearly"
  },
  "USER_ROLE": {
    "USER": "User",
    "EMPLOYEE": "Employee",
    "ADMIN": "Admin",
    "SUPER_ADMIN": "Super Admin",
    "ADMINISTRATOR": "Administrator"
  },
  "header": {
    "search": {
      "placeholder": "Find reservation"
    },
    "account": {
      "dropdown": {
        "profile": "Profile",
        "changePassword": "Change password",
        "logOut": "Log out",
        "admin": "Admin"
      }
    }
  },
  "footer": {
    "title": "All rights reserved"
  },
  "auth": {
    "welcome": {
      "title": "Have a successful working day",
      "subTitle": "In case of any questions, please, contact administration 0322500290"
    },
    "form": {
      "title": "Authorization",
      "username": "Username",
      "password": "Password",
      "button": "Log in",
      "twoFA": "SMS Code",
      "resend": "Resend"
    },
    "biometric": {
      "or": "or",
      "loginButton": "Login with Biometric",
      "enterUsername": "Please enter your username first",
      "loginFailed": "Biometric login failed",
      "noCredentials": "No biometric device registered. Please register a device first in your profile settings.",
      "userNotFound": "User not found",
      "cancelled": "Biometric authentication was cancelled"
    }
  },
  "DASHBOARD": {
    "ANALYSIS": {
      "analysisOfTheDay": "Analysis of the day",
      "newUser": "New user",
      "allReservations": "All reservations",
      "finishedVisits": "Finished visits",
      "visitsToBeMade": "Visits to be made",
      "totalRevenue": "Total Revenue",
      "averageTicket": "Average Ticket",
      "services": "Services",
      "products": "Products",
      "bookingDetails": "Booking Details",
      "pending": "Pending",
      "inProgress": "In Progress",
      "canceled": "Canceled",
      "noShow": "No Show",
      "occupancy": "Occupancy",
      "today": "Today",
      "week": "Week",
      "month": "Month",
      "availableSlots": "Available Slots",
      "tomorrow": "Tomorrow",
      "noSlots": "No available slots",
      "min": "min",
      "clientStats": "Client Statistics",
      "topVisitors": "Top Visitors",
      "topSpenders": "Top Spenders",
      "newClients": "New Clients",
      "newClientsRevenue": "New Clients Revenue",
      "returningClients": "Returning Clients",
      "returningClientsRevenue": "Returning Clients Revenue",
      "client": "Client",
      "visits": "Visits",
      "spent": "Spent",
      "noData": "No data available",
      "employees": "Employees",
      "rooms": "Rooms",
      "combined": "Combined",
      "salesTrend": "Sales trend",
      "days": "days",
      "vsYesterday": "vs yesterday"
    },
    "statistic": {
      "title": "Overview",
      "salary": "Income & salary",
      "latestReservations": "Latest reservations",
      "pastReservations": "Past reservations",
      "reservationsMadeToday": "Reservations made today"
    },
    "HEADER": {
      "FINDRESERVATION": "Find Reservation",
      "CHANGEPASSWORD": "Change Password",
      "LOGOUT": "Logout"
    }
  },
  "profile": {
    "userName": "Username",
    "phoneNumber": "Phone number",
    "idNumber": "ID number",
    "gender": "Gender",
    "dateOfBirth": "Date of birth",
    "email": "Email",
    "city": "City",
    "address": "Address",
    "additionalInformation": "Additional information",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "repeatPassword": "Repeat password",
    "changePassword": "Change password",
    "updateProfile": "Update profile",
    "passwordChange": "Password change",
    "disable2FA": "Disable 2FA",
    "enable2FA": "Enable 2FA",
    "2FAEnabled": "Two factor authentication is enabled",
    "2FADisabled": "Two factor authentication is disabled",
    "2FA": "Two factor authentication",
    "branch": {
      "title": "Branch",
      "add": "Add branch",
      "edit": "Edit branch",
      "delete": "Delete branch",
      "name": "Branch name",
      "physicalAddress": "Physical address",
      "mobile": "Mobile",
      "email": "Email",
      "city": "City",
      "country": "Country",
      "whStart": "Working hours start",
      "whEnd": "Working hours end",
      "smsBrandName": "SMS brand name",
      "deleteConfirm": "Are you sure you want to delete this branch?",
      "deleteSuccess": "Branch deleted successfully",
      "onlineBooking": "Online Booking",
      "workingHours": "Working Hours",
      "invoiceOrganizationName": "Organization Name on Invoice",
      "invoiceOrganizationTaxId": "Organization Tax ID on Invoice",
      "settings": "Settings"
    },
    "biometric": {
      "title": "Biometric Authentication",
      "deviceName": "Device",
      "lastUsed": "Last used",
      "noDevices": "No biometric devices registered",
      "addDevice": "Add device",
      "removeConfirm": "Are you sure you want to remove this device?",
      "registerSuccess": "Biometric device registered successfully",
      "registerFailed": "Failed to register biometric device",
      "removeSuccess": "Device removed successfully",
      "removeFailed": "Failed to remove device",
      "noPlatformAuth": "Touch ID or Windows Hello is not available on this device. Use a device with biometric hardware to register."
    },
    "fullName": "Full Name",
    "firstname": "First Name",
    "lastname": "Last Name",
    "bookingHubEnabled": "Online Booking Enabled",
    "bookingHubDisabled": "Online Booking Disabled",
    "bookingHubButtonDisable": "Disable Online Booking",
    "bookingHubButtonEnable": "Enable Online Booking",
    "bookingHubNotActive": "Booking Service Not Active",
    "bookingHubButtonActivate": "Activate Booking Service",
    "bookingHubEnableConfirm": "Are you sure you want to enable online booking?",
    "bookingHubDisableConfirm": "Are you sure you want to disable online booking?"
  },
  "employee": {
    "add": "Add",
    "massiveAddition": "Massive addition",
    "download": "Download",
    "delete": "Are you sure you want to delete?",
    "rollback": "Restore",
    "rollbackConfirm": "Are you sure you want to restore?",
    "resetPassword": "Are you sure you want to close the day?",
    "addEmployee/edit": "Add an employee/edit",
    "addPosition/edit": "Add position/edit",
    "addProcedure/edit": "Add a procedure/edit",
    "addRestDay": "Add a rest day",
    "procedure": "procedure",
    "canScheduleStartTime": "Work start time",
    "canScheduleEndTime": "Work end time",
    "tabs": {
      "employees": "Employees",
      "positions": "Positions"
    },
    "search": {
      "searchWord": "Search word",
      "position": "Position",
      "visibleInApp": "Visible in App",
      "inCalendar": "Visible in Calendar"
    },
    "form": {
      "firstName": "First name",
      "lastName": "Last name",
      "phoneNumber": "Phone number",
      "homePhone": "Home phone number",
      "idNumber": "ID number",
      "gender": "Gender",
      "female": "Female",
      "male": "Male",
      "dateOfBirth": "Date of birth",
      "email": "Email",
      "salaryType": "Salary type",
      "fixedSalary": "Fixed salary",
      "%ofGenerating": "% of generating",
      "additionalInformation": "Additional information",
      "showInCalendar": "Show in calendar",
      "showInApplication": "Show in application",
      "save": "Save",
      "add": "Add",
      "created": "Created",
      "errors": {
        "title": "Error",
        "requiredFields": "Please fill in the required fields (including first and last name).",
        "saveFailed": "Failed to save"
      },
      "salaryTypes": {
        "OUTPUT": "Output",
        "FIXED": "Fixed",
        "ALL": "All"
      }
    },
    "detailView": {
      "statistics": "Statistics",
      "reservations": "Reservations",
      "completedVisits": "Completed visits",
      "amountEarned": "Amount earned",
      "issuedAmount": "Issued amount",
      "information": "Information",
      "procedures": "Procedures",
      "finances": "Finances",
      "recoveryPassword": "Recovery password",
      "workSchedule": "Work schedule",
      "employeeProcedure": "employee procedure",
      "calendar": "Calendar",
      "identitySection": "Identity",
      "contactSection": "Contact",
      "employmentSection": "Employment"
    }
  },
  "services": {
    "addProcedure/edit": "Add procedure/edit",
    "addSpecialProcedure/edit": "Add special procedure/edit",
    "addProduct/edit": "Add a product/edit",
    "search": {
      "searchWord": "Search word",
      "onlineBooking": "Booking Hub-ში გამოჩენა",
      "vat": "With VAT"
    },
    "tabs": {
      "procedures": "Procedures",
      "specialProcedures": "Special procedures",
      "categories": "Categories",
      "regular": "Services",
      "offers": "Offers",
      "packages": "Packages"
    },
    "sections": {
      "basicInfo": "Basic Information",
      "pricing": "Pricing & Duration",
      "settings": "Settings"
    },
    "offers": {
      "offerName": "Offer",
      "remaining": "Remaining",
      "expires": "Expires",
      "prepaid": "Prepaid",
      "noOffers": "No offers found",
      "left": "left",
      "reserved": "used"
    },
    "packages": {
      "packageName": "Package",
      "coveredByPackage": "Covered by package",
      "noPackages": "No packages found",
      "noActivePackage": "No active packages",
      "noActivePackageDescription": "There are currently no active packages available",
      "noPackagesForSearch": "No packages found for \"{{term}}\"",
      "fromTemplate": "From template",
      "adHoc": "Custom",
      "adHocBundle": "Custom bundle",
      "addProcedure": "Add procedure",
      "noProcedures": "Add procedures to the bundle",
      "selectProcedure": "Select procedure",
      "total": "Total",
      "validityDays": "Validity (days)",
      "buyForAnother": "Buy for another customer",
      "selectBeneficiary": "Select beneficiary",
      "giftFrom": "Gift from",
      "boughtFor": "Bought for",
      "saveToTemplates": "Save to templates",
      "templateName": "Package name",
      "templateNameRequired": "Please enter a package name",
      "templateSaved": "Saved to templates",
      "templateSaveFailed": "Sold, but saving to templates failed"
    },
    "column": {
      "title": "Title",
      "price": "Price",
      "time": "Time",
      "priceAutomatically": "The price automatically",
      "timeAutomatically": "The time automatically",
      "category": "Category",
      "provider": "Provider",
      "vat": "VAT",
      "created": "Created",
      "providerPrice": "Provider price",
      "color": "Color",
      "position": "Position",
      "reminder": "Reminder",
      "reminderPeriod": "Reminder period",
      "reminderSmsTemplate": "Reminder SMS template",
      "discount": "Discount"
    },
    "form": {
      "title": "Title",
      "salePrice": "Sale price",
      "time": "Time",
      "category": "Category",
      "priceAutomatically": "The price automatically",
      "timeAutomatically": "The time automatically",
      "automaticTransfer": "Automatic transfer to fixed cost",
      "products": "Products",
      "notification": "Notification",
      "gram": "Gram",
      "piece": "Piece",
      "reminderInterval": "Reminder interval",
      "reminderNotification": "Reminder notification",
      "reminderMessage": "Specify a reminder message",
      "employee": "Employee",
      "%generating": "% of generating",
      "fixedSalary": "Fixed salary",
      "fixSum": "fixed cost",
      "onlineBooking": "Show in Booking Hub",
      "maxParallelBookings": "Max Parallel Bookings",
      "maxParallelBookingsHint": "0 = unlimited, N = max parallel bookings allowed",
      "ncsps": "NCSP Codes",
      "serviceType": "Service Type",
      "standard": "Standard",
      "minute": "Minutes",
      "minute-price": "Price per Minute",
      "minute-discount": "Minute Discount",
      "price": "Price",
      "discount": "Discount",
      "unit": "Unit",
      "inPiece": "grams per piece",
      "willUse": "Will use"
    },
    "category": {
      "add": {
        "title": "Add/Edit Category"
      }
    },
    "notifications": {
      "service": "Service",
      "updated": "Successfully updated",
      "created": "Successfully created",
      "error": "Error"
    },
    "v2": {
      "searchPlaceholder": "Search by service name",
      "summary": "Showing {{total}} services",
      "serviceCount": "Services: {{count}}",
      "uncategorized": "Uncategorised",
      "loadFailed": "Could not load",
      "toggleFailed": "Could not save the change",
      "column": {
        "name": "Name",
        "onlineBooking": "Online booking",
        "price": "Price",
        "duration": "Duration",
        "break": "Tech. break",
        "materials": "Materials",
        "employees": "Employees"
      },
      "form": {
        "newTitle": "New service",
        "newTitleSpecial": "New special procedure",
        "editTitleSpecial": "Edit special procedure",
        "editTitle": "Edit service",
        "tab": {
          "main": "Main settings",
          "online": "Online booking",
          "languages": "Languages",
          "products": "Products",
          "ncsp": "NCSP codes",
          "employees": "Employees",
          "rooms": "Rooms",
          "activity": "Activity"
        },
        "name": "Name",
        "category": "Category",
        "basePrice": "Base price",
        "useRange": "Specify a price range",
        "priceFrom": "from",
        "priceTo": "to",
        "duration": "Service duration",
        "hoursShort": "h",
        "minutesShort": "min",
        "onlineBooking": "Online booking",
        "publicName": "Name for online booking",
        "publicDescription": "Description",
        "publicHint": "Clients see this when booking online. It is independent of the internal name.",
        "languagesHint": "Add translations so clients see the service in their own language. When a translation is empty the main name is used.",
        "lang": {
          "ka": "Georgian",
          "en": "English",
          "ru": "Russian"
        },
        "standard": "Standard",
        "optional": "Optional",
        "fromMain": "Taken from main settings",
        "nameRequired": "Enter a name",
        "rangeIncomplete": "A range needs both bounds",
        "saved": "Saved",
        "saveFailed": "Could not save",
        "vat": "Subject to VAT",
        "saveFirst": "Save the service first — then you can add items here.",
        "viewOnly": "You can view this service but don't have permission to change it."
      },
      "create": "Create",
      "title": "Service categories",
      "subtitle": "Services",
      "on": "On",
      "off": "Off",
      "emptyCategory": "No services in this category yet",
      "addService": "Add",
      "filter": {
        "all": "All",
        "online": "Online booking",
        "inSalon": "In salon only",
        "special": "Special procedures"
      },
      "searchEmpty": "No service matches that name",
      "searchTruncated": "Showing the first 200 matches — narrow the search.",
      "chooser": {
        "title": "What would you like to create?",
        "new": "New",
        "category": {
          "title": "Service category",
          "hint": "A group of similar services, for example haircuts"
        },
        "service": {
          "title": "Service",
          "hint": "A single service performed by a specialist, for example a manicure"
        },
        "special": {
          "title": "Special procedure",
          "hint": "Performed in the salon only — it uses neither online booking nor an NCSP code"
        },
        "package": {
          "title": "Service package",
          "hint": "Several services sold as one offer, for example a manicure and a pedicure"
        }
      },
      "category": {
        "newTitle": "New service category",
        "editTitle": "Edit category",
        "namePlaceholder": "For example: Haircuts",
        "useOnlineName": "Use a different name for online booking",
        "onlineName": "Name for online booking",
        "nameRequired": "Enter a category name",
        "created": "Category created",
        "saved": "Category saved",
        "languagesHint": "Add translations so the category reads correctly in other languages.",
        "fallsBack": "If left empty, the Georgian name is shown",
        "viewOnly": "You can view this category but don't have permission to change it.",
        "colorHint": "Bookings for services in this category show in this colour on the calendar.",
        "reminderHint": "Sends the client an SMS a set number of days after a visit with a service from this category.",
        "reminderDays": "Send after (days)",
        "reminderDaysHint": "Counted from the visit date.",
        "reminderPlaceholders": "You can use {firstname} for the client's first name and {serviceCategoryName} for the category name.",
        "reminderIncomplete": "The reminder will not be sent until both the number of days and the SMS text are filled in.",
        "chooseColor": "Choose colour",
        "noColor": "No colour chosen"
      },
      "noBreak": "None",
      "minutesShort": "{{count}} min",
      "materialCount": "{{count}} materials",
      "reorderFailed": "Could not save the new order",
      "materials": {
        "search": "Search materials",
        "selected": "Selected materials",
        "noneFound": "No materials found",
        "noneSelected": "No materials selected yet",
        "lowStock": "Running low",
        "inStock": "{{count}} in stock",
        "gram": "g",
        "piece": "pcs",
        "costPerService": "Material cost per service",
        "servicePrice": "Service price",
        "margin": "Margin",
        "writeOffHint": "Materials can be changed at any time — reopen the materials cell in the table.",
        "footerHint": "Once saved, these materials are added automatically to every new booking of this service.",
        "title": "Bind materials",
        "expired": "Expired",
        "expiresOn": "Expires {{date}}"
      },
      "breakHint": "Minutes the room stays blocked after the service",
      "rooms": {
        "tabLabel": "Rooms",
        "hint": "Tick the rooms this service can be performed in.",
        "none": "This branch has no rooms.",
        "selected": "{{count}} room(s) selected",
        "saved": "Rooms saved",
        "saveFailed": "Could not save the rooms",
        "loadFailed": "Could not load the rooms"
      },
      "activity": {
        "none": "Nothing has changed yet.",
        "unknown": "Unknown",
        "empty": "empty",
        "yes": "Yes",
        "no": "No",
        "loadFailed": "Could not load the history",
        "action": {
          "CREATED": "Created",
          "UPDATED": "Updated",
          "DELETED": "Deleted",
          "ONLINE_BOOKING": "Online booking",
          "EMPLOYEES": "Employees",
          "ROOMS": "Rooms",
          "PRODUCTS": "Products"
        },
        "count": "{{count}} item(s)"
      },
      "addLink": "Add",
      "notSetShort": "—",
      "countSalon": "{{count}} in salon",
      "countOnline": "{{count}} online",
      "employeesDrawer": {
        "title": "Service employees"
      },
      "import": {
        "title": "Import from Excel",
        "subtitle": "Bulk-update prices and durations and add new services.",
        "dropTitle": "Drop an Excel file here or choose one from your computer",
        "dropHint": "xlsx format, up to 5 MB",
        "choose": "Choose file",
        "remove": "Remove file",
        "checkTitle": "File check",
        "checking": "Checking...",
        "count": {
          "create": "New",
          "update": "To update",
          "unchanged": "Unchanged",
          "warning": "Warnings",
          "error": "Errors"
        },
        "table": {
          "row": "Row",
          "service": "Service",
          "message": "Message"
        },
        "showAll": "Show all rows",
        "showProblems": "Only rows with problems",
        "allClean": "No problems found in the file.",
        "footerNote": "Rows with errors are skipped. {{create}} will be created, {{update}} updated.",
        "done": "Import finished: {{create}} created, {{update}} updated.",
        "resultDiffers": "The result differs from the check: the data changed after the file was checked.",
        "onlineSummary": "Online booking: {{on}} switched on, {{off}} switched off",
        "cancel": "Cancel",
        "confirm": "Confirm import",
        "close": "Close",
        "wrongType": "Only .xlsx files are accepted.",
        "tooLarge": "The file is larger than 5 MB.",
        "failed": "The file could not be processed. Please try again.",
        "redesignDisabled": "The new services screen is turned off for this branch.",
        "forbidden": "You do not have access to this branch.",
        "column": {
          "id": "ID",
          "name": "Name",
          "category": "Category",
          "price": "Price",
          "discountPrice": "Discount price",
          "time": "Duration",
          "serviceType": "Type",
          "vat": "VAT",
          "autoPrice": "Show price automatically",
          "autoTime": "Show time automatically",
          "technicalBreak": "Technical break",
          "maxParallel": "Max parallel bookings",
          "autoFix": "Auto-transfer to fixed expense",
          "fixSum": "Fixed expense amount",
          "onlineBooking": "Online booking"
        },
        "msg": {
          "nameRequired": "Name is required",
          "notANumber": "\"{{column}}\" is not a number",
          "negative": "\"{{column}}\" cannot be negative",
          "notPositive": "\"{{column}}\" must be greater than 0",
          "invalidValue": "\"{{column}}\": value not allowed",
          "serviceNotFound": "Service not found in this branch",
          "duplicateId": "This ID appears twice in the file",
          "categoryWillBeCreated": "A new category will be created: {{name}}",
          "priceRangeKept": "This service has a price range: the price changes, the range stays",
          "notXlsx": "The file is not an Excel (.xlsx) file",
          "emptyFile": "The file is empty",
          "missingNameColumn": "The file has no \"Name\" column",
          "tooManyRows": "The file has more than {{max}} rows",
          "unknownColumn": "Unknown column \"{{name}}\" was skipped",
          "unknown": "Unknown error",
          "duplicateName": "Duplicate name in this category",
          "tooLarge": "The file is too large once unpacked.",
          "notWholeNumber": "\"{{column}}\" must be a whole number",
          "breakNotForMinute": "A MINUTE service has no technical break (use 0 or leave empty)",
          "fixSumIgnored": "The transfer is off, so the amount is saved as 0",
          "onlineBookingUnavailable": "Online booking is turned off for the organization"
        }
      },
      "excel": {
        "menu": "Excel actions",
        "export": "Export to Excel",
        "exportHint": "All services matching the current filter.",
        "import": "Import from Excel",
        "importHint": "Bulk-update prices and durations.",
        "template": "Download template",
        "templateHint": "An empty file with the right columns.",
        "exportFailed": "Export failed.",
        "templateFailed": "Could not download the template."
      },
      "delete": {
        "titleService": "Delete service: {{name}}",
        "titleServiceNoName": "Delete service",
        "titleCategory": "Delete category: {{name}}",
        "titleCategoryNoName": "Delete category",
        "checking": "Checking...",
        "confirmService": "This service will be deleted. Are you sure?",
        "confirmCategory": "This category will be deleted. Are you sure?",
        "historyKept": "Past visits are kept.",
        "blocked": "Cannot be deleted",
        "bookings": "Upcoming bookings: {{count}}",
        "offers": "Active offers: {{count}}",
        "packages": "Active packages: {{count}}",
        "purchases": "Package purchases with unused sessions: {{count}}",
        "vouchers": "Unredeemed vouchers: {{count}}",
        "services": "Services in the category: {{count}} — delete or move them first",
        "delete": "Delete",
        "cancel": "Cancel",
        "close": "Close",
        "done": "Deleted",
        "failed": "Could not delete. Please try again.",
        "forbidden": "You do not have access to this branch.",
        "redesignDisabled": "The new services screen is turned off for this branch.",
        "notFound": "Not found — it may already be deleted.",
        "button": "Delete"
      }
    }
  },
  "users": {
    "consentsHistory": "Consents & Verification",
    "consent": {
      "documentType": "Document type",
      "verified": "Verified",
      "verifiedYes": "Yes",
      "verifiedNo": "No",
      "search": "Search",
      "clear": "Clear",
      "type": {
        "PROCEDURE_CONSENT": "Procedure consent",
        "CUSTOMER_VERIFICATION": "Customer verification",
        "DATA_PROCESSING": "Data processing",
        "INFORMED_CONSENT": "Informed consent"
      },
      "status": {
        "VERIFIED": "Verified",
        "PENDING": "Pending",
        "CONFIRMED": "Confirmed",
        "EXPIRED": "Expired"
      },
      "column": {
        "type": "Type",
        "status": "Status",
        "code": "Code",
        "verified": "Verified",
        "verifiedAt": "Verified at",
        "mobilePhone": "Phone",
        "date": "Date"
      }
    },
    "gel": "GEL",
    "min": "min.",
    "information": "information",
    "addUser/edit": "Add an user/edit",
    "sections": {
      "personalInfo": "Personal Information",
      "contactInfo": "Contact Information",
      "additionalInfo": "Additional Information"
    },
    "upBalance": "Top-up the balance",
    "minutes": "Minutes",
    "amount": "The amount",
    "numberMinutes": "Number of minutes",
    "typePayment": "Type of payment",
    "moneyMode": "Money transaction",
    "withoutMoney": "Without a money transaction",
    "withMoney": "With a money transaction",
    "moneyRequired": "An operation with a money transaction needs an amount above 0",
    "comment": "Comment",
    "operationType": "Operation type",
    "topUpBalance": "Top-up balance",
    "returnBalance": "Return balance",
    "balanceAmount": "balance amount",
    "historyVisits": "History of visits",
    "transactions": "Transactions",
    "completedSuccessfully": "completed successfully",
    "balanceFilledSuccessfully": "The balance was filled successfully",
    "balanceNotEnough": "The balance is not enough",
    "verified": "Verified",
    "choose": "Choose",
    "search": {
      "searchWord": "Search word",
      "branch": "Branch",
      "userSource": "User Source",
      "withBalance": "With balance",
      "withMinutes": "With minutes",
      "results": " results",
      "placeholder": "Search by name, last name, phone number, ID number...",
      "startTyping": "Start typing to search..."
    },
    "transactionDate": "Transaction date",
    "column": {
      "cardNo": "The card #",
      "name": "Name",
      "lastName": "Last name",
      "identificationNo": "Identification #",
      "female": "Female",
      "male": "Male",
      "gender": "Gender",
      "dateOfBirth": "Date of birth",
      "phoneNumber": "Phone number",
      "branch": "Branch",
      "userSource": "User Source",
      "created": "Created",
      "role": "Role",
      "service": "Service",
      "price": "Price",
      "balance": "Balance(₾)",
      "minutes": "Minutes",
      "reservationTime": "Reservation time",
      "startingTime": "Starting time",
      "finishingTime": "Finishing time",
      "employee": "Employee",
      "description": "Description",
      "cashback": "Cashback",
      "medicalSpecialty": "Medical Specialty"
    },
    "form": {
      "cardNo": "The card #",
      "name": "Name",
      "lastName": "Last name",
      "phoneNumber": "Phone number",
      "homePhone": "Home phone number",
      "female": "Female",
      "male": "Male",
      "gender": "Gender",
      "dateOfBirth": "Date of birth",
      "idNumber": "ID number",
      "email": "Email",
      "additionalInformation": "Additional information",
      "role": "Role",
      "created": "Created",
      "userSource": "User Source",
      "smsLanguage": "SMS language",
      "smsLanguageKa": "Georgian",
      "smsLanguageRu": "Russian",
      "smsLanguageEn": "English",
      "verification": "Verification",
      "notSet": "Not set",
      "smsLanguageHint": "The language this client receives SMS in",
      "smsLanguageSaved": "SMS language saved",
      "smsLanguageError": "Could not save the language",
      "selectUser": "Change customer",
      "updateUser": "Update customer",
      "unknownUser": "Unknown customer",
      "smsLanguageDefault": "branch default"
    },
    "offers": {
      "tabTitle": "Packages",
      "title": "Purchased Packages",
      "buyPackage": "Buy Package",
      "package": "Package",
      "status": "Status",
      "source": "Source",
      "progress": "Progress",
      "price": "Price",
      "validity": "Validity",
      "actions": "Actions",
      "noOffers": "No packages found",
      "beneficiary": "Beneficiary",
      "expired": "Expired",
      "expiringSoon": "Expiring Soon",
      "activate": "Activate",
      "confirmActivate": "Confirm Activation",
      "activateWarning": "Are you sure you want to activate this package?",
      "activated": "Package activated successfully",
      "purchaseSuccess": "Purchase Successful",
      "packagePurchased": "Package purchased successfully",
      "status_PURCHASED": "Purchased",
      "status_ACTIVE": "Active",
      "status_USED": "Used",
      "status_CANCELLED": "Cancelled",
      "status_SHARED": "Shared",
      "selectPackage": "Select Package",
      "selectPackagePlaceholder": "Select a package to purchase",
      "paymentMethod": "Payment Method",
      "purchasePrice": "Purchase Price",
      "note": "Note",
      "notePlaceholder": "Enter a note (optional)",
      "purchase": "Purchase",
      "noPackagesAvailable": "No packages available",
      "noPackagesDescription": "There are no packages available for internal sale at the moment",
      "available": "Available",
      "originalPrice": "Original Price",
      "discountedPrice": "Discounted Price",
      "discount": "Discount",
      "servicesCount": "Services Count",
      "includedServices": "Included Services",
      "useBalance": "Use Balance"
    },
    "ehr": {
      "onlyWithIntervention": "With interventions only"
    },
    "preferencesAndNotes": "Preferences and notes",
    "visitPhotos": "Visit photos",
    "giftPackages": "Received as gifts",
    "servicePackages": "Service packages",
    "ownPackages": "Own packages"
  },
  "calendar": {
    "gel": "GEL",
    "offerService": "Offer",
    "packageService": "Package",
    "packageClearFailed": "Could not fully clear the previous customer's package from this visit",
    "serviceDeleted": "Service deleted",
    "minute": "Minutes",
    "hours": "Hours",
    "day": "Day",
    "sortEmployee": "Sort employee",
    "planVisit": "Plan a visit",
    "createUser": "Create a user",
    "calendarTitle": "Calendar",
    "PlanVisit": "Plan a visit",
    "services": "Services",
    "addProcedure": "Add a procedure",
    "addProduct": "Add a product",
    "editProduct": "Edit product",
    "specialProcedures": "special procedures",
    "addSpecialProcedure": " Add a special procedure",
    "form": {
      "user": "User",
      "birthdayToday": "Birthday today",
      "birthdayGreeting": "Birthday greeting",
      "employee": "Employee",
      "employeeLocked": "The employee cannot be changed once a procedure has been added",
      "employeeBusy": "The employee is busy at this time",
      "startTime": "Start time",
      "userRequest": "With a user request",
      "date": "Date",
      "startingTime": "Starting time",
      "finishingTime": "Finishing time",
      "comment": "Comment",
      "fixatedExpense": "Fixated expense",
      "expense": "expense",
      "paymentMethod": "Payment method",
      "balance": "balance",
      "available": "available",
      "cash": "Cash",
      "bank": "via bank",
      "minutes": "Minutes",
      "exchange": "Exchange",
      "consignment": "Consignment",
      "bankTransfer": "Bank transfer",
      "gel": "GEL",
      "sumTotal": "Sum total",
      "present": "Present",
      "sendNotification": "Send a notification",
      "withCash": "Payment with cash",
      "procedure": "Procedure",
      "procedureAndPrice": "Procedure & price",
      "name": "Name",
      "lastName": "Last name",
      "phoneNumber": "Phone number",
      "duration": "Duration",
      "time": "time",
      "price": "Price",
      "discount": "Discount ",
      "percent": "percent",
      "discountedPrice": "Discounted price",
      "fixatedSalary": "Fixated salary",
      "salary%": "Salary %",
      "fromValue": "from value",
      "numberProcedures": " Number of procedures",
      "expenses": "Expense",
      "products": "Products",
      "gram": "Gram",
      "quantity": "Quantity",
      "product": "product",
      "piece": "piece",
      "specialProcedure": "special procedure",
      "specialist": "Specialist",
      "salary": "salary",
      "inStock": "In stock",
      "debt": "debt",
      "room": "Room",
      "selectRoom": "Select room",
      "source": "Booking Source",
      "sourcePlaceholder": "Select source",
      "additionalEmployees": "Additional Employees",
      "employees": "Employees",
      "addEmployee": "Add Employee",
      "selectEmployee": "Select Employee",
      "verified": "Verified",
      "errors": {
        "dateRangeError": "The start time should not exceed the end time",
        "totalPrice": "The total price is incorrect"
      },
      "unit": "Unit",
      "willUse": "Will use"
    },
    "week": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    },
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "popup": {
      "employee": "Employee",
      "user": "User",
      "mobilePhone": "Mobile phone",
      "procedure": "Procedure",
      "price": "Price",
      "discount": "Discount",
      "times": "Times",
      "comment": "Comment",
      "bookedAt": "Booked at",
      "bookedBy": "Booked by",
      "completedBy": "Completed by",
      "status": "Status",
      "balance": "Balance",
      "source": "Source",
      "additionalEmployee": "Additional employee",
      "room": "Room",
      "paidAmount": "Paid"
    },
    "allDayOff": "Day Off",
    "tooltip": {
      "calendar": "Calendar",
      "employeeCard": "Employee card"
    },
    "menu": {
      "newVisit": "New visit",
      "employeeDay": "Employee calendar",
      "block": "Block time",
      "blockConfirm": "Mark the whole day off for {{name}} ({{date}})?",
      "blockSuccess": "Day marked as off"
    },
    "status": {
      "confirmed": "Confirmed",
      "inProgress": "In progress",
      "completed": "Completed",
      "noShow": "No show"
    },
    "unknownClient": "Unknown",
    "notWorking": "Day off",
    "saveError": "Failed to save changes",
    "hold": {
      "tooltip": "Slot held for an online payment — cannot be booked over",
      "genericSource": "Online hold",
      "ariaLabel": "Hold via {{source}}, {{start}}–{{end}}, not available to book"
    },
    "pendingOnline": {
      "title": "Pending online booking",
      "tooltip": "Awaiting confirmation — go to Online Booking to accept or decline",
      "overlapWarningTitle": "This slot overlaps a pending online booking",
      "overlapWarningContent": "{{name}}, {{start}}–{{end}}, ₾{{paid}} of ₾{{total}} paid. Book anyway?",
      "overlapWarningConfirm": "Book anyway",
      "overlapWarningUnknownCustomer": "Customer"
    },
    "confirmedOnline": {
      "label": "Online"
    }
  },
  "recordings": {
    "start": "Start",
    "finish": "Finish",
    "deleted": "Deleted",
    "status": "Status",
    "service": "Service",
    "price": "Price",
    "reservationTime": "Reservation time",
    "startingTime": "Starting time",
    "finishingTime": "Finishing time",
    "employee": "Employee",
    "room": "Room",
    "source": "Source",
    "user": "User",
    "mobilePhone": "Mobile phone",
    "createdBy": "Created by",
    "created": "Created",
    "cancellationDate": "Cancellation date",
    "cancelledBy": "Cancelled by",
    "cancellationReason": "Cancellation reason",
    "download": "Download"
  },
  "statistic": {
    "detailSearch": {
      "operationSource": {
        "reservation": "reservation",
        "salary": "Salary",
        "realization": "Realization",
        "expense": "Expense",
        "purchase": "Purchase",
        "popOpBalance": " Top-up balance",
        "returnBalance": "Return balance",
        "cashRegister": "Cash register"
      },
      "operationType": {
        "procedure": "procedure",
        "specialProcedure": "Special procedure",
        "accrualSalary": "Accrual of salary",
        "salaryDisbursement": "Salary disbursement",
        "sell": "Sell",
        "spend": "Spend",
        "purchase": "Purchase",
        "expense": "Expense",
        "topUpBalance": "Top-up balance",
        "spendBalance": "Spend the balance",
        "returnBalance": "Return balance"
      },
      "search": {
        "start": "Start",
        "finish": "Finish",
        "employee": "Employee",
        "user": "User",
        "procedureCategory": "Procedure category",
        "category": "Category",
        "procedure": "Procedure",
        "room": "Room",
        "source": "Source",
        "expenseCategory": "Expense category",
        "expenseSubCategory": "Expense sub-category",
        "sourceOperation": "Source of operation",
        "operationType": "Operation type",
        "product": "Product",
        "productCategory": "Product category",
        "productProvider": "Product provider",
        "reservation": "reservation",
        "productCodeBarcode": "Product code or barcode"
      },
      "column": {
        "operationNumber": "#",
        "date": "Date",
        "sourceOperation": "Source of operation",
        "type": "Type",
        "paymentMethod": "Payment method",
        "service": "Service",
        "category": "Category",
        "time": "Time",
        "user": "User",
        "price": "Price",
        "discountPrice": "Discount price",
        "discount%": "Discount %",
        "fixatedExpense": "Fixated expense",
        "specialProcedureExpense": "Special procedure expense",
        "employee": "Employee",
        "employeeSalary": "Salary",
        "expenseCategory": "expense category",
        "nameProduct": "Name of the product",
        "barcode": "Barcode",
        "provider": "provider",
        "quantity": "Quantity",
        "capacity": "Capacity",
        "created": "Created",
        "createdBy": "Who created"
      },
      "detailView": {
        "user": "User",
        "created": "Created",
        "comment": "Comment",
        "employee": "Employee",
        "createdBy": "Created by",
        "sumTotal": "Sum total",
        "type": "Type",
        "procedures": "procedures",
        "reservationDate": "Reservation date",
        "nameLastName": "Name, Last Name",
        "time": "Time",
        "price": "Price",
        "position": "Position",
        "fixatedExpense": "Fixated expense",
        "additionalExpense": "Additional expense",
        "discountPrice": "Discount price",
        "employee%": "Employee %",
        "products": "Products",
        "barcode": "Barcode",
        "nameProduct": "Name of the product",
        "service": "Service",
        "capacity": "Capacity",
        "quantity": "Quantity",
        "salary": "salary",
        "fixated%": "Fixated %",
        "employeeSalary": "Salary",
        "transaction": "Transaction",
        "transaction#": "Transaction #",
        "transactionType": "Transaction type",
        "paymentMethod": "Payment method",
        "cash": "Cash",
        "card": "Card",
        "bank": "Bank",
        "balance(GEL)": "Balance (GEL)",
        "status": "Status",
        "addAmount": "Add the amount",
        "amount": "The amount",
        "gel": "GEL",
        "salaryDisbursement": "Salary disbursement",
        "Products": "Products ",
        "expenses": "expenses",
        "balance": "Balance"
      }
    },
    "operation": {
      "operationSource": {
        "reservation": "reservation",
        "salary": "Salary",
        "realization": "Realization",
        "expense": "Expense",
        "purchase": "Purchase",
        "popOpBalance": " Top-up balance",
        "returnBalance": "Return balance",
        "cashRegister": "Cash register"
      },
      "search": {
        "start": "Start",
        "finish": "Finish",
        "operationNumber": "Operation number",
        "sourceOperation": "Source of operation",
        "employee": "Employee",
        "user": "User",
        "createdBy": "Created By",
        "bank": "Bank"
      },
      "column": {
        "operationNumber": "#",
        "sourceOperation": "Source of operation",
        "paymentMethod": "Payment method",
        "date": "date",
        "price": "Price",
        "cash": "Cash",
        "card": "Card",
        "bank": "Bank",
        "bankName": "Bank name",
        "balance": "Balance (GEL)",
        "minutes": "Balance(minute)",
        "user": "User",
        "employee": "Employee",
        "createdBy": "Created by",
        "procedure": "Procedure",
        "created": "Created",
        "seeDetails": "See details",
        "barter": "Barter"
      }
    },
    "transaction": {
      "search": {
        "start": "Start",
        "finish": "Finish",
        "paymentMethod": "Payment method",
        "deleted": "deleted"
      },
      "column": {
        "transaction#": "Trans.#",
        "date": "Date",
        "created": "Created",
        "transactionType": "Transaction type",
        "paymentMethod": "Payment method",
        "paid": "Paid",
        "cash": "Cash",
        "card": "Card",
        "bank": "Bank",
        "balance(GEL)": "Balance (GEL)",
        "price": "Price",
        "discountPrice": "Discount price",
        "discount%": "Discount %",
        "fixatedExpense": "Fixated expense",
        "specialProcedureExpense": "Special procedure expense",
        "comment": "Comment",
        "createdBy": "Created by",
        "transaction": "Transaction",
        "user": "User",
        "bankName": "Bank Name",
        "status": "Status"
      }
    },
    "consignation": {
      "consignmentCoverage": "Consignment coverage",
      "paymentMethod": "Payment method",
      "comment": "Comment",
      "search": {
        "start": "Start",
        "finish": "Finish",
        "user": "User",
        "status": "Status",
        "toPaid": "To be paid",
        "paid": "Paid",
        "totalPayment": "Total payment",
        "gel": "GEL"
      },
      "column": {
        "date": "Date",
        "user": "User",
        "price": "Price",
        "discountPrice": "Discount price",
        "ToPaid": "To be paid",
        "cash": "Cash",
        "card": "Card",
        "bank": "Bank",
        "consignment": "Consignment",
        "covered": "Covered",
        "status": "Status",
        "employee": "Employee",
        "created": "Created",
        "issued": "To be paid",
        "paid": "Paid"
      },
      "error": {
        "max": "Maximum coverage amount is {{max}} GEL"
      },
      "title": "Consignation"
    }
  },
  "profitLoss": {
    "search": {
      "start": "Start",
      "finish": "Finish"
    },
    "column": {
      "date": "Date",
      "income": "Income",
      "cash": "Cash ",
      "cashless": "Cashless",
      "fixatedExpense": "Fixated expense",
      "expense": "Expense",
      "expenseCash": "Expense in cash",
      "cashlessExpense": "Cashless expense",
      "salaries": "Salaries",
      "otherExpenses": "Other expenses",
      "profit": "Profit",
      "profitFixatedExpense": "Profit-Fixated expense",
      "addMoney": "Add money in Cashier",
      "subMoney": "Subtract money from Cashier"
    }
  },
  "diagrams": {
    "graphicDiagrams": "Graphic diagrams",
    "incomeProcedures": "Income via procedures",
    "incomeCategories": "Income via categories",
    "clients": "Clients",
    "products": "Products",
    "start": "Start",
    "finish": "Finish",
    "procedure": "Procedure",
    "sumTotal": "Sum total",
    "quantity": "Quantity",
    "categoriesIncome": "Procedure categories income",
    "procedureCategory": "Procedure category"
  },
  "expense": {
    "expenseType": "Expense type",
    "category": "Category",
    "toPaid": "To be paid",
    "amount": "The amount",
    "viaBank": "Via bank",
    "comment": "Specify a comment",
    "issueExpense": "Issue an expense",
    "expenseCategories": "Expense categories",
    "addExpense": "Add expense",
    "nameExpense": "The name of the expense",
    "subCategory": "sub-category",
    "expenseProcessing": "Expense processing",
    "addSubCategory": "sub-category",
    "date": "expense date",
    "close": "Close",
    "paymentMethod": {
      "label": "Payment method",
      "cash": "Cash",
      "card": "Card",
      "transfer": "Transfer"
    },
    "bank": "Bank",
    "total": "Total",
    "payableTotal": "Payable total",
    "issueSuccess": "Expense issued successfully",
    "noSubcategory": "No subcategory added",
    "required": "This field is required",
    "viewDeleted": "Show deleted",
    "deleted": "Deleted"
  },
  "booking": {
    "productExpense": "Product expense",
    "additionalExpense": "Additional expense",
    "totalExpense": "Total expense"
  },
  "marketing": {
    "reminder": {
      "created": "Created",
      "user": "User",
      "serviceCategory": "Service category",
      "lastVisit": "Last visit",
      "reminderPeriod": "Reminder period",
      "remindDate": "Remind date",
      "isSent": "Is sent"
    },
    "smsHistory": {
      "search": {
        "start": "Start",
        "finish": "Finish",
        "sender": "Sender",
        "receiver": "Receiver",
        "user": "User",
        "reminderSource": "Reminder source"
      },
      "created": "Created",
      "smsType": "SMS type",
      "sender": "Sender",
      "receiver": "Receiver",
      "user": "User",
      "reminderSource": "Reminder source",
      "reminderPeriod": "Reminder period",
      "notification": "Notification"
    },
    "smsTemplate": {
      "yourTemplate": "Your template",
      "addTemplateEdit": "Add a template/edit",
      "addTemplate": "Add a template",
      "branchConfig": "Branch configuration",
      "advancedSmsEnabled": "Advanced SMS",
      "defaultLanguage": "Default language",
      "reminderOffsets": "Reminder timing",
      "eventEnabled": "Enabled",
      "previewTest": "Preview / Test",
      "language": "Language",
      "preview": "Preview",
      "noPreview": "No preview available",
      "testPhone": "Phone",
      "sendTest": "Send test",
      "configSaved": "Settings saved",
      "eventToggled": "Event updated",
      "testSentOk": "Test SMS sent",
      "testSentFail": "Failed to send test SMS",
      "saveFailed": "Failed to save",
      "toggleError": "Failed to update status",
      "title": "SMS notifications",
      "subtitle": "Manage this branch's SMS notifications: which events send them, in which language, and with which template.",
      "statusOn": "On",
      "statusOff": "Off",
      "event": "Event",
      "languages": "Languages",
      "hasOverride": "Branch template set",
      "usesDefault": "Uses default text",
      "noEvents": "No events found",
      "systemDefault": "Message text",
      "branchOverride": "Your version",
      "insertField": "Insert field:",
      "chars": "chars",
      "reminderOffsetsHelp": "Set how many minutes before the appointment to send the reminder (e.g. 1440 = 1 day, 120 = 2 hours).",
      "defaultLanguageHelp": "Used to send an SMS when the client's preferred language is unknown.",
      "advancedSmsEnabledHelp": "Turns on this branch's own SMS system: per-language templates, per-event on/off, and custom reminder timing.",
      "remindersHeading": "Appointment reminders",
      "fixedReminderLabel": "1 day before, at 17:00 (always on)",
      "additionalReminderLabel": "Extra reminder before the visit",
      "additionalReminderHelp": "Optionally send one more reminder a set time before each appointment.",
      "unitMinutes": "minutes",
      "unitHours": "hours",
      "reminderRange": "The reminder must be between 5 minutes and 1 day.",
      "clearReminder": "Clear"
    },
    "birthday": {
      "title": "Birthdays",
      "subtitle": "Who has a birthday coming up. The automatic greeting is sent only on the day itself; a manual greeting can be sent any day.",
      "range": "Period",
      "branch": "Branch",
      "allBranches": "All branches",
      "customer": "Customer",
      "birthDate": "Birthday",
      "daysLeft": "Days left",
      "phone": "Phone",
      "lastBranch": "Branch",
      "statusColumn": "Status",
      "greetedToday": "greeted",
      "notGreeted": "not greeted yet",
      "today": "today",
      "inDays": "in {{n}} days",
      "todayGroup": "Today",
      "upcomingGroup": "Upcoming",
      "noneToday": "Nobody has a birthday today.",
      "manualRule": "Manual sending works on any day. The automatic greeting goes out only on the birthday itself.",
      "loadFailed": "Could not load the list",
      "sendSelected": "Send greeting",
      "confirmTitle": "Send to {{count}} customers?",
      "confirmTemplate": "Template: {{template}}",
      "confirmRepeat": "Template: {{template}}. {{count}} of them already received a greeting within the past year.",
      "templatePlaceholder": "Template",
      "noTemplates": "No templates yet — create one in settings",
      "featureDisabledHint": "Birthday greetings are switched off — enable them in settings",
      "sendFailedGeneric": "Could not send",
      "greetedOn": "greeted — {{date}}",
      "status": {
        "SENT": "sent",
        "ALREADY_SENT": "already greeted today",
        "NO_PHONE": "no phone number",
        "NO_BRANCH": "no branch could be resolved",
        "NO_SENDER": "the branch has no SMS sender",
        "NO_TEMPLATE": "no active template in this language",
        "NOT_ELIGIBLE": "not eligible (no birth date, no phone number, or not a customer of this organization)",
        "FAILED": "failed"
      },
      "config": {
        "title": "Birthday configuration",
        "subtitle": "Automatic greeting settings and message templates. Settings apply to the whole organization.",
        "isActive": "Automatic sending",
        "isActiveHint": "Once on, greetings are sent automatically every day",
        "stateOn": "on",
        "stateOff": "off",
        "sendHour": "Sending hour",
        "sendHourHint": "Tbilisi time, 0 to 23",
        "sendHourError": "Enter an hour between 0 and 23",
        "minVisits": "Minimum visits",
        "minVisitsHint": "A customer with fewer visits is not greeted",
        "minVisitsError": "At least 1",
        "save": "Save",
        "saved": "Saved",
        "saveFailed": "Could not save",
        "confirmTitle": "Turn automatic sending on",
        "confirmBody": "Every day at {{hour}}:00 Tbilisi time, every qualifying customer in the whole organization is sent an SMS automatically. Each message costs money.",
        "confirmOk": "Turn on"
      },
      "template": {
        "title": "Templates",
        "add": "Add template",
        "edit": "Edit template",
        "editAction": "Edit",
        "name": "Name",
        "nameError": "A name is required",
        "language": "Language",
        "message": "Message",
        "messageError": "A message is required",
        "isDefault": "Default",
        "isActive": "Active",
        "active": "active",
        "inactive": "off",
        "defaultWarning": "This language already has a default template. Saving will switch it off.",
        "save": "Save",
        "cancel": "Cancel",
        "saved": "Saved",
        "saveFailed": "Could not save",
        "loadFailed": "Could not load the templates"
      },
      "widget": {
        "title": "Birthdays",
        "seeAll": "See all",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "week": "In the coming week",
        "none": "No birthdays in the coming week.",
        "failed": "Could not load birthdays."
      }
    }
  },
  "MassiveUploadProcedures": {
    "title": "Massive upload of the procedures",
    "p1": "When adding the procedure, it is necessary that the uploaded information is entered into the already prepared Excel file, the template of which can be downloaded by clicking on the \"template\" button",
    "p2": "Drag the name of the procedures from your files to the mentioned form along with other information and upload it to the system",
    "p3": "Please note that the category, provider and provider's product name shall be 100% consistent between the existing entry in the program and the one indicated by you in the Excel, otherwise, a new category of the provider and provider's product will be created in the software."
  },
  "massiveUploadProduct": {
    "title": "Massive upload of the product with a file",
    "p1": "When uploading a product, it is necessary that your balances are entered into an already prepared excel form, the template of which can be downloaded by clicking on the button 'Download template'",
    "p2": "Drag the products information from your files to the mentioned file and upload it to the system.",
    "p3": "Please note that the name of the supplier and the category shall be 100% consistent between the record already in the program and the one indicated by you in the Excel, otherwise a new category or supplier will be created in the software."
  },
  "massiveUploadUser": {
    "title": "Massive upload of user by  file",
    "p1": "When uploading a customer base, it is necessary that their information is entered into an already prepared excel form, the template of which can be downloaded by clicking on the button \"Download template\". ",
    "p2": "Drag customer information from your files to the mentioned file and upload it to the system.",
    "p3": "Please note that the information must be 100% consistent with the name of the fields."
  },
  "validators": {
    "percentRange": "Percent must be between 0 and 100",
    "required": "Indication is mandatory",
    "personalId11Digits": "Personal ID must be exactly 11 digits",
    "email": "Email is not valid",
    "minTimeRequired": "Minimum time is 00:00",
    "PleaseEnterUser": "Please, enter the name of the user",
    "PleaseEnterPassword": "Please, enter the correct password",
    "incorrectUsername": "Incorrect username",
    "incorrectPassword": "Incorrect password",
    "indicateCurrentPassword": "Indicate current password!",
    "indicateNewPassword": "Indicate new password!",
    "repeatedPasswordMandatory": "Indicating a repeated password is mandatory",
    "passwordMatch": "Password doesn't match",
    "nextDayCashbox": "Next day cashbox cannot be opened",
    "sureCloseDayYesNo": "Are you sure you want to close the day? Yes/No"
  },
  "notifications": {
    "indicationMandatory": "Indication is mandatory",
    "minTimeRequired": "Minimum time is 00:00",
    "PleaseEnterUser": "Please, enter the name of the user",
    "PleaseEnterPassword": "Please, enter the correct password",
    "incorrectUsername": "Incorrect username",
    "incorrectPassword": "Incorrect password",
    "indicateCurrentPassword": "Indicate current password!",
    "indicateNewPassword": "Indicate new password!",
    "repeatedPasswordMandatory": "Indicating a repeated password is mandatory",
    "passwordMatch": "Password doesn't match",
    "nextDayCashbox": "Next day cashbox cannot be opened",
    "sureCloseDayYesNo": "Are you sure you want to close the day? Yes/No"
  },
  "buttons": {
    "newRecord": "New record",
    "cancel": "Cancel",
    "withFile": "Add with a file",
    "download": "Download",
    "save": "Save",
    "create": "Create",
    "view": "View",
    "close": "Close",
    "deletePop": "Are you sure you want to delete?",
    "massiveUpload": "Massive upload",
    "edit": "Edit",
    "delete": "Delete",
    "remove": "Remove",
    "update": "Update",
    "updateHistory": "Update history",
    "stockAccounting": "Stock accounting",
    "finishPop": "Are you sure you want to finish?",
    "finish": "Finish",
    "search": "Search",
    "clear": "Clear",
    "pay": "Pay",
    "template": "Template",
    "chooseFile": "Choose a file",
    "upload": "Upload",
    "decline": "Decline",
    "accept": "Accept",
    "sendSms": "Send SMS",
    "sendEmail": "Send Email",
    "selectAll": "Select All",
    "add": "Add"
  },
  "search": {
    "searchWord": "Search word",
    "category": "Category",
    "distributor": "Distributor"
  },
  "specifyingNeccessary": "Specifying is neccessary",
  "findReservation": {
    "reservation": "reservation",
    "employee": "Employee",
    "user": "User",
    "phoneNumber": "phone number",
    "procedure": "Procedure",
    "price": "Price",
    "gel": "GEL"
  },
  "organization": {
    "name": "Name",
    "subdomain": "Website address",
    "legalName": "Legal name",
    "orgPrefix": "Organization prefix",
    "registrationNumber": "Registration number",
    "physicalAddress": "Physical address",
    "legalAddress": "Legal address",
    "mobile": "Director Mobile",
    "phone": "Branch Mobile",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "webpage": "Webpage",
    "tiktok": "Tiktok",
    "youtube": "Youtube",
    "description": "Description",
    "email": "Email",
    "update": "Update",
    "onlineBooking": "Online booking",
    "printConfig": {
      "title": "Print Header & Footer",
      "configure": "Configure",
      "saved": "Print config saved",
      "headerLogo": "Header Logo",
      "uploadLogo": "Upload Logo",
      "headerTitle": "Header Title",
      "headerTitlePlaceholder": "Company / document title",
      "footerLine1": "Footer Line 1",
      "footerLine1Placeholder": "Address, phone, etc.",
      "footerLine2": "Footer Line 2",
      "footerLine2Placeholder": "Website, email, etc.",
      "showPageNumbers": "Show Page Numbers",
      "inherited": "Inherited from org",
      "resetToOrg": "Reset to org default",
      "savePrintConfig": "Save Print Config",
      "signatureImage": "Signature Image",
      "uploadSignature": "Upload Signature"
    }
  },
  "location": {
    "country": "Country",
    "region": "Region",
    "municipality": "Municipality",
    "city": "City",
    "district": "District",
    "selectCountry": "Select country",
    "selectRegion": "Select region",
    "selectMunicipality": "Select municipality",
    "selectCity": "Select city",
    "selectDistrict": "Select district"
  },
  "bookinghub": {
    "activate": {
      "title": "Bookinghub.ge activation",
      "description": "Please enter your mobile number and password to activate Bookinghub.ge service",
      "mobilePhone": "Mobile Number",
      "password": "Password"
    }
  },
  "onlineCatalog": {
    "title": "Bookinghub Services",
    "subtitle": "Manage online services for BookingHub",
    "branchServices": "Branch Services",
    "addService": "Add Service",
    "editService": "Edit Service",
    "serviceName": "Service Name",
    "category": "Category",
    "price": "Price",
    "duration": "Duration",
    "employees": "Employees",
    "status": "Status",
    "noServicesConfigured": "No online services configured",
    "addFirstService": "Add first service",
    "selectService": "Select Service",
    "selectServicePlaceholder": "Search and select a service from the catalog",
    "suggestedPrice": "Suggested Price",
    "suggestedDuration": "Suggested Duration",
    "from": "from",
    "upTo": "up to",
    "minutes": "minutes",
    "serviceAdded": "Service added successfully",
    "serviceUpdated": "Service updated successfully",
    "serviceDeleted": "Service deleted successfully",
    "serviceActivated": "Service activated",
    "serviceDeactivated": "Service deactivated",
    "confirmDelete": "Are you sure you want to delete this service?",
    "assignEmployees": "Assign Employees",
    "noEmployees": "No employees assigned",
    "employeesCount": "employees",
    "employeeName": "Employee Name",
    "position": "Position",
    "customPrice": "Custom Price",
    "customDuration": "Custom Duration",
    "defaultPrice": "Default Price",
    "defaultDuration": "Default Duration",
    "selectedEmployees": "Selected Employees",
    "employeesAssigned": "Employees assigned successfully",
    "noEmployeesAvailable": "No employees available",
    "bulkAddServices": "Bulk Add Services",
    "searchServices": "Search services...",
    "selectAll": "Select All",
    "selectedCount": "Selected",
    "addSelected": "Add Selected",
    "selectAtLeastOneService": "Please select at least one service",
    "servicesAddedCount": "{{count}} services added successfully",
    "servicesSkippedCount": "{{count}} services skipped (already added)",
    "noServicesFound": "No services found",
    "startTime": "Start Time",
    "endTime": "End Time",
    "searchEmployee": "Search by name or position",
    "searchService": "Search service...",
    "allCategories": "All Categories",
    "requestService": "Request Service",
    "serviceRequest": {
      "title": "Request New Service",
      "description": "If you can't find the desired service or category in the catalog, you can submit a request and we will consider adding it.",
      "type": "Type",
      "typePlaceholder": "Select type",
      "typeService": "Service",
      "typeCategory": "Category",
      "name": "Name",
      "namePlaceholder": "Enter the desired service or category name",
      "success": "Request sent successfully",
      "error": "Failed to send request"
    }
  },
  "notification": {
    "permission_denied": "You have blocked notifications. Please enable notifications in your browser settings to receive updates.",
    "permission_default": "You have not yet allowed notifications. Please allow notifications in your browser settings to receive updates.",
    "permission_request": "Enable notifications"
  },
  "packageUserLimit": "Hello, we would like to inform you that the limit of the number of employees of the license available for your company has been exceeded. The maximum number of employees allowed is ({{userLimit}}), please adjust the number accordingly, if you have any questions, please contact us: 0322500290\nThank you for using our service.",
  "notificationTitle": "Notification",
  "serverError": "Server error. Please try again later.",
  "ALERT": {
    "important_info": "Important information",
    "important_update": "Important update"
  },
  "ERX": {
    "myErx": "My prescriptions",
    "edit": "Edit prescription",
    "add": "Add prescription",
    "info": "Information",
    "mainInfo": "Main information",
    "sendTitle": "Send prescription",
    "download": "Print prescription",
    "send": "Send",
    "print": "Print",
    "syncDoctor": "Activate electronic prescription",
    "activate": "Activate",
    "syncDoctorSuccess": "Doctor activated successfully",
    "alreadySynced": "Doctor is already activated",
    "syncDoctorError": "Incorrect username or password",
    "userError": "User error",
    "confirmSendPrescription": "Are you sure you want to send?",
    "notSelectedProductWarning": "Please specify the medicine",
    "disableRecipeTitle": "Cancel prescription",
    "disableReason": "Reason for cancellation",
    "chooseProduct": "Choose medicine",
    "chooseProductTitle": "Select from the list of medicines",
    "patient": "Patient",
    "doctor": "Doctor",
    "title": "E-Rx",
    "status": "Status",
    "dosagePriv": "Substitution possible",
    "isCopy": "Copy",
    "isOnlyGeneric": "Only generic",
    "isOnlyTradeable": "Only tradeable",
    "unid": "Prescription #",
    "sendAt": "Send date",
    "recipeNo": "Recipe #",
    "user": "User",
    "users": "Users",
    "productId": "Medicine code",
    "medicamentId": "Medicine code",
    "tradeName": "Medicine",
    "generic": "Generic",
    "prodCount": "Quantity",
    "periodInput": "Period",
    "procedureSmsText": "Notification text",
    "periodType": "Periodicity",
    "durationInput": "Prescription validity period",
    "ds": "Prescription",
    "createdAt": "Creation date",
    "needToSend": "To be sent",
    "sent": "Sent",
    "cancelled": "Cancelled",
    "firstName": "First name",
    "lastName": "Last name",
    "identityNo": "Personal number",
    "birthDate": "Date of birth",
    "contactNo": "Contact number",
    "email": "Email",
    "certificateNo": "Certificate number",
    "product": {
      "productID": "Product code",
      "GeoNDC": "National drug code",
      "AtcCode": "ATC code",
      "IssuanceMode": "Issuance mode",
      "GeoTradeName": "Trade name (Geo)",
      "EngTradeName": "Trade name (Eng)",
      "ProductGeneric": "Generic",
      "Api": "Active ingredient",
      "PharmaTherapyGroup": "Pharmacotherapeutic group",
      "Manufacturer": "Manufacturer",
      "ManufacturerCountryName": "Manufacturer country",
      "RegistrationTill": "Registration validity",
      "OtherDetailsGeo": "Other details (Geo)",
      "OtherDetailsEng": "Other details (Eng)",
      "DisableReason": "Reason for deregistration"
    },
    "branch": "Branch"
  },
  "general": {
    "save": "Save",
    "edit": "Edit",
    "close": "Close",
    "cancel": "Cancel",
    "send": "Send",
    "input": "Input",
    "import": "Import",
    "select": "Select"
  },
  "UNKNOWN": "Unknown",
  "USER": {
    "cardNo": "Card Number",
    "firstname": "First Name",
    "lastname": "Last Name",
    "mobilePhone": "Mobile Phone",
    "phone": "Home Phone",
    "identityNumber": "ID Number",
    "gender": "Gender",
    "birthDate": "Date of Birth",
    "email": "Email",
    "description": "Additional Information"
  },
  "EMPLOYEE": {
    "cardNo": "Card Number",
    "firstname": "First Name",
    "lastname": "Last Name",
    "mobilePhone": "Mobile Phone",
    "phone": "Home Phone",
    "identityNumber": "ID Number",
    "gender": "Gender",
    "birthDate": "Date of Birth",
    "email": "Email",
    "description": "Additional Information",
    "workType": "Salary Type",
    "fixedSalary": "Fixed Salary",
    "outputPercent": "Output %",
    "inCalendar": "Show in Calendar",
    "visibleInApp": "Visible in App",
    "workOff": {
      "planDay": "Plan Day",
      "planCalendar": "Plan Calendar",
      "workHours": "Work Hours",
      "breakHours": "Break",
      "vacation": "Vacation",
      "dayOff": "Day Off",
      "download": "Download",
      "workStart": "Arrival",
      "workEnd": "Departure",
      "breakStart": "Break Start",
      "breakEnd": "Break End",
      "clearDays": "Clear Schedule",
      "selectYear": "Select Year",
      "selectMonth": "Select Month",
      "selectWeekday": "Select Weekday",
      "workInterval": "Work Time",
      "breakInterval": "Break Time",
      "addVacation": "Add Vacation",
      "selectDate": "Select Date",
      "exclamation": "If no days are selected, all days are assumed to be selected",
      "messageCreatedDayOff": "Day Off successfully added to calendar",
      "messageCreatedVacation": "Vacation days successfully added to calendar",
      "messagePlannedCalendar": "Calendar planning completed successfully",
      "errorWorkTime": "Arrival time exceeds departure time",
      "errorBreakTime": "Break start time exceeds break end time",
      "planWorkdaysTooltip": "To plan specific days, select dates on the calendar",
      "clearDataByMonth": "You are clearing the monthly schedule, are you sure?",
      "clearDataByYear": "You are clearing the yearly schedule, are you sure?",
      "clearDataTitle": "Clear Schedule"
    }
  },
  "WORKTYPE": {},
  "INSURANCE": {
    "name": "Name",
    "salePercent": "Discount Percent",
    "contactName": "Contact Person",
    "contactPhone": "Contact Phone",
    "contactMobile": "Contact Mobile",
    "provider": "Provider"
  },
  "locale": {
    "en": "English",
    "ka": "Georgian",
    "ru": "Russian"
  },
  "userStatus": {
    "add-or-edit": "Add/Edit Status",
    "active": "Active",
    "inactive": "Inactive",
    "name": "Name",
    "description": "Description"
  },
  "userSource": {
    "title": "User Sources",
    "name": "Name",
    "namePlaceholder": "Enter source name",
    "type": "Type",
    "status": "Status",
    "createdAt": "Created",
    "global": "Global",
    "custom": "Custom",
    "active": "Active",
    "inactive": "Inactive",
    "readOnly": "Read Only",
    "add": "Add Source",
    "edit": "Edit Source",
    "search": "Search"
  },
  "serverErrors": {
    "INSUFFICIENT_BALANCE": "Insufficient balance for this payment",
    "INSUFFICIENT_MINUTES": "Insufficient minutes for this payment",
    "INVALID_SALARY_AMOUNT": "Invalid salary amount",
    "signature-pad-disabled": "The signature pad is not enabled for this branch.",
    "Insufficient permissions": "You don't have permission to do this"
  },
  "addVisit": {
    "buttons": {
      "saveVisit": "Save",
      "cancel": "Cancel Visit",
      "addService": "Add Procedure",
      "addProduct": "Add Product",
      "continue": "Continue",
      "close": "Close",
      "savePayment": "Payment"
    },
    "form": {
      "isAnonymous": "Anonymous User",
      "anonymousName": "User Name",
      "withOutService": "Without Procedure",
      "sendNotification": "Send Notification",
      "sendToMobile": "Send to Mobile"
    },
    "sendRecipe": {
      "title": "Send Payment Receipt",
      "success": "Sent Successfully",
      "error": "Error Sending",
      "successMessage": "Payment receipt sent successfully",
      "errorMessage": "Error sending payment receipt"
    },
    "errors": {
      "paymentTitle": "Payment Error",
      "totalPriceMismatch": "Payment total must match the total amount",
      "deletedServiceTitle": "The visit can't be completed",
      "deletedServiceContent": "These services were deleted: {{names}}. Replace or remove them in the visit, then complete it."
    }
  },
  "SHARED": {
    "SEE_MORE": "See More",
    "PREFIX": "Prefix",
    "LEGAL_ADDRESS": "Legal Address",
    "SMS_BRAND_NAME": "SMS Brand Name",
    "EHR_USERNAME": "EHR Username",
    "EHR_PASSWORD": "EHR Password",
    "PHYSICAL_ADDRESS": "Physical Address",
    "DIRECTOR_FIRSTNAME": "Director First Name",
    "DIRECTOR_LASTNAME": "Director Last Name",
    "MOBILE_NUMBER": "Mobile Number",
    "CONTACT_NUMBER": "Contact Number",
    "ORGANIZATION": "Organization",
    "BRAND_NAME": "Brand Name",
    "USER_NAME": "User",
    "ID_NUMBER_EMPTY": "ID number field is empty",
    "CONTINUE": "Continue",
    "SEE_LESS": "See Less",
    "REALLY_WANT_DELETE": "Are you sure you want to delete?",
    "YES": "Yes",
    "NO": "No",
    "ADD": "Add",
    "START": "Start",
    "END": "End",
    "START_END": "Start/End",
    "DOWNLOAD": "Download",
    "DATE": "Date",
    "DOCTOR": "Doctor",
    "PROCEDURES": "Procedures",
    "DETAILED": "Detailed",
    "IN_DETAILS": "In Details",
    "DETAILS": "Details",
    "NAME_SURNAME": "Name Surname",
    "PERSONAL_NUMBER": "Personal Number",
    "TELEPHONE": "Telephone",
    "MOBILE": "Mobile",
    "ADDRESS": "Address",
    "IDENTIFICATION_CODE": "Identification Code",
    "DATE_OF_BIRTH": "Date of Birth",
    "BIRTHDAY": "Birthday",
    "INSURANCE": "Insurance",
    "NAME": "Name",
    "PHONE_NUMBER": "Phone Number",
    "MAIL": "Email",
    "FIRST_NAME": "First Name",
    "LAST_NAME": "Last Name",
    "CREATED_AT": "Created At",
    "COMMENT": "Comment",
    "FILTER": "Filter",
    "CHOOSE": "Choose",
    "SEARCH": "Search",
    "DATE_ERROR_MESSAGE": "Start time cannot exceed end time",
    "FUTURE_DATE_ERROR_MESSAGE": "Cannot complete booking with future date",
    "DATE_ERROR_TITLE": "Time Error",
    "PLEASE_SUBMIT_THE_FILE": "Please upload file",
    "SERVICE": "Service",
    "WHO_APPOINTMENT": "Who Booked",
    "CREATED": "Created",
    "DATE_OF_CANCELLATION": "Cancellation Date",
    "CANCELED": "Canceled",
    "appointment": "Appointments",
    "PROCEDURE": "Procedure",
    "CANCEL": "Canceled",
    "APPOINTMENT": "Booked",
    "COMPLETED": "Completed",
    "PROCESSING": "In Progress",
    "NOTIFICATION": "Notification",
    "NOTIFICATION_DEFAULT_TEXT": "Feature coming soon...",
    "BOOKING_DOCTOR": "Booking Doctor",
    "BOOKING_DATE": "Booking Date",
    "INFORMATION_NOT_SAVED": "Changes are not saved, do you want to navigate away?",
    "find_booking": "Find Booking",
    "invoice": "Invoice",
    "year": "Year",
    "month": "Month",
    "week": "Week",
    "day": "Day"
  },
  "common": {
    "unsavedChangesTitle": "Unsaved changes",
    "unsavedChanges": "Do you want to save?",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "noData": "No data available",
    "month": "Month",
    "year": "Year",
    "uploading": "Uploading...",
    "yes": "Yes",
    "no": "No",
    "days": "days",
    "actions": "Actions",
    "edit": "Edit",
    "error": "Error",
    "save": "Save",
    "add": "Add",
    "submit": "Submit"
  },
  "REPORTS": {
    "VISITS": {
      "DATE_FROM": "Date from",
      "DATE_TO": "Date to",
      "STATUS": "Status",
      "SEARCH_NAME": "Search name",
      "SEARCH": "Search",
      "RESET": "Reset",
      "EXPORT": "Export",
      "ID": "ID",
      "VISIT_DATE": "Visit Date",
      "FULL_NAME": "Full Name",
      "TOTAL_PAID": "Total Paid",
      "STATUS_COL": "Status",
      "ACTIONS": "Actions",
      "DOWNLOAD_INVOICE": "Download invoice",
      "STATUS_VALUES": {
        "PENDING": "Pending",
        "CONFIRMED": "Confirmed",
        "IN_PROGRESS": "In Progress",
        "COMPLETED": "Completed",
        "CANCELED": "Canceled",
        "DELETED": "Deleted"
      }
    }
  },
  "ehrTemplate": {
    "title": "Electronic Health Record Templates",
    "createButton": "Create Template",
    "searchPlaceholder": "Search by name or description",
    "noData": "No templates found",
    "active": "Active",
    "inactive": "Inactive",
    "general": "General",
    "custom": "Custom",
    "useTooltip": "Use template",
    "viewTooltip": "View template",
    "editTooltip": "Edit template",
    "deleteTooltip": "Delete template",
    "deleteConfirm": "Are you sure you want to delete this template?",
    "columns": {
      "name": "Name",
      "description": "Description",
      "isActive": "Status",
      "isGeneral": "Type",
      "createdAt": "Created At",
      "updatedAt": "Updated At"
    },
    "form": {
      "title": "Electronic Health Record Template",
      "createTitle": "Create Template",
      "editTitle": "Edit Template",
      "viewTitle": "View Template",
      "name": "Template Name",
      "namePlaceholder": "Enter template name",
      "nameError": "Template name is required",
      "description": "Description",
      "descriptionPlaceholder": "Enter template description",
      "descriptionError": "Description is too long",
      "content": "Template Content",
      "contentPlaceholder": "Enter template content in JSON format",
      "contentError": "Invalid content format",
      "isActive": "Active Status",
      "isGeneral": "General Template",
      "cancel": "Cancel",
      "create": "Create",
      "update": "Update",
      "close": "Close"
    }
  },
  "room": {
    "title": "Room Management",
    "createButton": "Create Room",
    "dragToReorder": "Drag rows to reorder rooms",
    "active": "Active",
    "inactive": "Inactive",
    "visible": "Visible",
    "hidden": "Hidden",
    "multiEmployee": "Multi-Employee",
    "singleEmployee": "Single Employee",
    "unlimited": "Unlimited",
    "viewTooltip": "View Room Details",
    "editTooltip": "Edit Room",
    "deleteTooltip": "Delete Room",
    "deleteConfirm": "Are you sure you want to delete this room?",
    "columns": {
      "name": "Name",
      "description": "Description",
      "isActive": "Active",
      "visibleInCalendar": "Calendar Visibility",
      "canWorkMultipleEmployees": "Multiple Employees",
      "maxParallelBookings": "Parallel Bookings",
      "order": "Order",
      "createdAt": "Created At",
      "actions": "Actions"
    },
    "form": {
      "name": "Room Name",
      "namePlaceholder": "Enter room name",
      "nameError": "Please enter a room name",
      "description": "Description",
      "descriptionPlaceholder": "Enter room description",
      "order": "Display Order",
      "orderPlaceholder": "Enter display order",
      "orderError": "Order must be 0 or greater",
      "isActive": "Active",
      "visibleInCalendar": "Visible in Calendar",
      "canWorkMultipleEmployees": "Allow Multiple Employees",
      "maxParallelBookings": "Max Parallel Bookings",
      "maxParallelBookingsHint": "0 = unlimited, 1 = single booking, N = max count"
    },
    "view": {
      "tabs": {
        "info": "Info & Stats",
        "services": "Room Services",
        "scheduler": "Scheduler"
      },
      "info": {
        "details": "Room Details",
        "statistics": "Statistics",
        "totalRevenue": "Total Revenue",
        "totalBookings": "Total Bookings",
        "completedVisits": "Completed Visits",
        "pendingVisits": "Pending Visits",
        "assignedServices": "Assigned Services",
        "scheduledDays": "Scheduled Days",
        "displayOrder": "Display Order"
      },
      "services": {
        "title": "Assigned Services",
        "serviceName": "Service Name",
        "serviceCategory": "Category",
        "assignedDate": "Assigned Date",
        "actions": "Actions",
        "addButton": "Add Service",
        "removeTooltip": "Remove Service",
        "removeConfirm": "Are you sure you want to remove this service from the room?",
        "noServices": "No services assigned to this room",
        "searchPlaceholder": "Search services...",
        "selectCategories": "Select service categories to filter",
        "servicesSelected": "services selected"
      },
      "scheduler": {
        "title": "Room Schedule",
        "date": "Date",
        "shiftStart": "Shift Start",
        "shiftEnd": "Shift End",
        "status": "Status",
        "breaks": "Breaks",
        "actions": "Actions",
        "addButton": "Add Schedule",
        "deleteTooltip": "Delete Schedule",
        "noSchedules": "No schedules found",
        "startDate": "Start Date",
        "endDate": "End Date",
        "status_AVAILABLE": "Available",
        "status_UNAVAILABLE": "Unavailable",
        "status_MAINTENANCE": "Maintenance",
        "planButton": "Plan Schedule",
        "planTooltip": "Select dates on the calendar to plan schedule",
        "selectDates": "Please select dates on the calendar"
      }
    }
  },
  "bookingSources": {
    "title": "Booking Sources",
    "addButton": "Add Source",
    "createTitle": "New Source",
    "editTitle": "Edit Source",
    "confirmDelete": "Are you sure you want to delete this source?",
    "table": {
      "icon": "Icon",
      "name": "Name",
      "status": "Status",
      "actions": "Actions"
    },
    "form": {
      "name": "Source Name",
      "namePlaceholder": "Enter source name",
      "nameError": "Please enter source name",
      "icon": "Icon",
      "iconPlaceholder": "Enter icon (emoji)",
      "iconHelp": "Enter an emoji or icon identifier"
    },
    "messages": {
      "createSuccess": "Source created successfully",
      "updateSuccess": "Source updated successfully",
      "deleteSuccess": "Source deleted successfully",
      "createError": "Failed to create source",
      "editError": "Failed to update source",
      "deleteError": "Failed to delete source",
      "toggleError": "Failed to change status",
      "activateSuccess": "Source activated",
      "deactivateSuccess": "Source deactivated"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    }
  },
  "service": {
    "price": "Price",
    "duration": "Duration"
  },
  "offers": {
    "title": "Offers",
    "types": {
      "fullPayment": "Full Payment",
      "partialPayment": "Partial Payment"
    },
    "categories": {
      "offer": "Offer",
      "package": "Package"
    },
    "activationMethods": {
      "fixedPeriod": "Fixed Period",
      "onPurchase": "On Purchase",
      "manual": "Manual Activation"
    },
    "status": {
      "active": "Active",
      "running": "Running",
      "completed": "Completed",
      "cancelled": "Cancelled"
    },
    "filters": {
      "search": "Search offers...",
      "status": "Status",
      "branch": "Branch",
      "startDate": "Start date",
      "endDate": "End date",
      "category": "Category",
      "internalSale": "Internal Sale"
    },
    "columns": {
      "image": "Image",
      "name": "Name",
      "category": "Category",
      "price": "Price",
      "quantity": "Quantity",
      "dates": "Dates",
      "status": "Status",
      "platforms": "Platforms",
      "actions": "Actions",
      "service": "Service",
      "onlineService": "Online Service",
      "employees": "Employees",
      "qty": "Qty",
      "originalPrice": "Original Price",
      "discountedPrice": "Discounted Price"
    },
    "labels": {
      "sale": "Sale",
      "valid": "Valid",
      "cover": "Cover",
      "totalOriginal": "Total Original",
      "totalDiscounted": "Total Discounted",
      "discount": "Discount",
      "internalSale": "Internal",
      "serviceNumber": "Service"
    },
    "buttons": {
      "create": "Create Offer",
      "viewStats": "Purchase Statistics",
      "viewAnalytics": "Analytics",
      "actions": "Actions",
      "duplicate": "Duplicate",
      "publishBookingHub": "Publish to BookingHub",
      "unpublishBookingHub": "Unpublish from BookingHub",
      "deactivate": "Deactivate Offer",
      "delete": "Delete",
      "addService": "Add Service",
      "uploadImage": "Upload Image",
      "setCover": "Set as Cover"
    },
    "tabs": {
      "basicInfo": "Basic Info",
      "translations": "Translations",
      "services": "Services",
      "onlineServices": "Online Services",
      "dates": "Dates",
      "branches": "Branches",
      "branch": "Branch",
      "images": "Images",
      "settings": "Settings"
    },
    "form": {
      "createTitle": "Create Offer",
      "editTitle": "Edit Offer",
      "category": "Category",
      "frontName": "Display Name",
      "frontNamePlaceholder": "Name shown to customers",
      "frontNameHint": "This name will be displayed to customers on booking platforms",
      "name": "Internal Name",
      "namePlaceholder": "Internal reference name",
      "description": "Description",
      "descriptionPlaceholder": "Describe what this offer includes...",
      "totalQuantity": "Total Quantity",
      "pricePlaceholder": "Enter quantity",
      "offerType": "Offer Type",
      "services": "Included Services",
      "selectService": "Select a service",
      "selectOnlineService": "Select an online service",
      "selectEmployees": "Select employees",
      "salePeriod": "Sale Period",
      "salePeriodHint": "The period during which this offer can be purchased",
      "activationDate": "Sale Start",
      "endDate": "Sale End",
      "validityPeriod": "Validity Period",
      "validityPeriodHint": "The period during which the offer can be redeemed",
      "validityStartDate": "Valid From",
      "expiryDate": "Valid Until",
      "branches": "Available Branches",
      "selectBranches": "Select branches",
      "branchesHint": "Select the branches where this offer can be redeemed",
      "branch": "Branch",
      "selectBranch": "Select branch",
      "branchHint": "First select a branch, then you can choose online services and employees",
      "imagesHint": "Upload at least 5 images for the offer",
      "minimum": "minimum",
      "notifyMerchant": "Notify Merchant on Sale",
      "notifyMerchantHint": "Send notification when an offer is sold",
      "bookingHubCategory": "BookingHub Category ID",
      "bookingHubCategoryPlaceholder": "Enter category ID",
      "bookingHubCategoryHint": "Category ID for BookingHub platform",
      "packageSettings": "Package Settings",
      "activationMethod": "Activation Method",
      "activationMethodHint": "How the package becomes active after purchase",
      "activeDays": "Active Days",
      "activeDaysPlaceholder": "Number of days",
      "activeDaysHint": "Number of days the package is valid after activation",
      "allowInternalSale": "Allow Internal Sale",
      "allowInternalSaleHint": "Enable internal sale of this package at the branch"
    },
    "messages": {
      "created": "Offer created successfully",
      "updated": "Offer updated successfully",
      "deleted": "Offer deleted successfully",
      "duplicated": "Offer duplicated successfully",
      "deactivated": "Offer deactivated successfully",
      "published": "Offer published to BookingHub",
      "unpublished": "Offer unpublished from BookingHub",
      "loadError": "Failed to load offer",
      "saveError": "Failed to save offer",
      "deleteError": "Failed to delete offer",
      "duplicateError": "Failed to duplicate offer",
      "deactivateError": "Failed to deactivate offer",
      "publishError": "Failed to publish offer",
      "unpublishError": "Failed to unpublish offer",
      "uploadError": "Failed to upload image",
      "noServices": "No services added yet. Click 'Add Service' to include services in this offer."
    },
    "validation": {
      "minServices": "Please add at least one service",
      "minImages": "Please upload at least 5 images"
    },
    "confirm": {
      "deactivate": "Are you sure you want to deactivate this offer?",
      "delete": "Are you sure you want to delete this offer?"
    }
  },
  "offerStats": {
    "title": "Offer Purchases",
    "status": {
      "active": "Active",
      "used": "Used",
      "cancelled": "Cancelled"
    },
    "filters": {
      "search": "Search by name, phone, ID...",
      "status": "Status",
      "source": "Source",
      "branch": "Branch",
      "offer": "Offer",
      "startDate": "Start date",
      "endDate": "End date"
    },
    "columns": {
      "externalId": "External ID",
      "offer": "Offer",
      "user": "Customer",
      "price": "Price",
      "progress": "Usage",
      "source": "Source",
      "status": "Status",
      "purchaseDate": "Purchase Date",
      "actions": "Actions"
    },
    "labels": {
      "validUntil": "Valid until",
      "remaining": "remaining",
      "usedAt": "Used",
      "cancelledAt": "Cancelled"
    },
    "buttons": {
      "cancel": "Cancel Purchase"
    },
    "paymentTypes": {
      "cash": "Cash",
      "card": "Card",
      "transfer": "Bank Transfer"
    },
    "cancelModal": {
      "title": "Cancel Purchase",
      "operationType": "Operation Type",
      "withoutRefund": "Cancel without refund",
      "withRefund": "Cancel with refund",
      "refundAmount": "Refund Amount",
      "paymentType": "Payment Type",
      "confirm": "Confirm Cancel"
    },
    "messages": {
      "cancelled": "Purchase cancelled successfully",
      "cancelError": "Failed to cancel purchase"
    }
  },
  "offerAnalytics": {
    "title": "Offer Analytics",
    "filters": {
      "branch": "Branch",
      "startDate": "Start date",
      "endDate": "End date"
    },
    "summary": {
      "totalRevenue": "Total Revenue",
      "totalSold": "Total Sold",
      "commission": "Commission",
      "totalPurchases": "Total Purchases"
    },
    "charts": {
      "dailyRevenue": "Daily Revenue",
      "revenueByOffer": "Revenue by Offer",
      "categoryRevenue": "Revenue by Category",
      "statusDistribution": "Status Distribution",
      "sourceDistribution": "Source Distribution",
      "revenueTable": "Revenue Details"
    },
    "columns": {
      "offer": "Offer",
      "quantity": "Quantity",
      "revenue": "Revenue",
      "status": "Status",
      "count": "Count",
      "percentage": "Percentage",
      "source": "Source",
      "category": "Category"
    },
    "labels": {
      "total": "Total",
      "offer": "Offer",
      "revenue": "Revenue",
      "category": "Category",
      "commission": "Commission"
    },
    "status": {
      "active": "Active",
      "used": "Used",
      "cancelled": "Cancelled"
    },
    "sources": {
      "onlineBookings": "Online Bookings",
      "bookinghub": "BookingHub",
      "swoop": "Swoop"
    },
    "empty": {
      "noData": "No data available for the selected period"
    }
  },
  "offerView": {
    "stats": {
      "price": "Price",
      "sold": "Sold",
      "remaining": "Remaining",
      "services": "Services"
    },
    "sections": {
      "images": "Images",
      "services": "Included Services",
      "onlineServices": "Online Services",
      "translations": "Translations",
      "details": "Details",
      "dates": "Dates",
      "platforms": "Platforms",
      "branches": "Available Branches",
      "purchaseStats": "Purchase Statistics",
      "packageSettings": "Package Settings"
    },
    "columns": {
      "service": "Service",
      "quantity": "Qty",
      "originalPrice": "Original Price",
      "discountedPrice": "Discounted Price",
      "employees": "Employees"
    },
    "fields": {
      "id": "ID",
      "category": "Category",
      "offerType": "Offer Type",
      "status": "Status",
      "notifyMerchant": "Notify on Sale",
      "bookingHubCategory": "BookingHub Category",
      "salePeriod": "Sale Period",
      "validityPeriod": "Validity Period",
      "createdAt": "Created",
      "frontName": "Display Name",
      "name": "Internal Name",
      "description": "Description",
      "activationMethod": "Activation Method",
      "activeDays": "Active Days",
      "allowInternalSale": "Internal Sale"
    },
    "languages": {
      "ka": "Georgian",
      "en": "English",
      "ru": "Russian"
    },
    "labels": {
      "total": "Total"
    },
    "published": "Published",
    "notPublished": "Not Published",
    "empty": {
      "noImages": "No images uploaded",
      "noServices": "No services added",
      "noTranslation": "Translation not available",
      "notFound": "Offer not found"
    },
    "purchaseStats": {
      "totalRevenue": "Total Revenue",
      "totalPurchases": "Total Purchases",
      "commission": "Commission",
      "commissionPercent": "Commission %",
      "statusDistribution": "Status Distribution",
      "sourceDistribution": "Source Distribution",
      "status": "Status",
      "source": "Source",
      "count": "Count",
      "revenue": "Revenue",
      "noData": "No purchase data available",
      "statuses": {
        "active": "Active",
        "used": "Used",
        "cancelled": "Cancelled"
      }
    }
  },
  "validation": {
    "required": "This field is required"
  },
  "dashboard": {
    "title": "Dashboard",
    "totalRevenue": "Total Revenue",
    "todayRevenue": "Today's Revenue",
    "services": "Services",
    "products": "Products",
    "averageTicket": "Average Ticket",
    "bookings": "Bookings",
    "totalBookings": "Total Bookings",
    "completedBookings": "Completed",
    "canceledBookings": "Canceled",
    "noShowBookings": "No Show",
    "pendingBookings": "Pending",
    "inProgressBookings": "In Progress",
    "occupancy": "Occupancy",
    "employeeOccupancy": "Employees",
    "roomOccupancy": "Rooms",
    "combinedOccupancy": "Combined",
    "today": "Today",
    "week": "Week",
    "month": "Month",
    "availableSlots": "Available Slots",
    "todaySlots": "Today",
    "tomorrowSlots": "Tomorrow",
    "noAvailableSlots": "No available slots",
    "minutes": "min",
    "clientStats": "Client Statistics",
    "topVisitors": "Top Visitors",
    "topSpenders": "Top Spenders",
    "newClients": "New Clients",
    "returningClients": "Returning Clients",
    "clientName": "Client",
    "visitCount": "Visits",
    "totalSpent": "Total Spent",
    "revenue": "Revenue",
    "count": "Count"
  },
  "ehr": {
    "successfullySaved": "Successfully saved",
    "saveFailed": "Save failed",
    "errorSending": "Failed to send to EHR",
    "successfullySent": "Successfully sent to EHR",
    "ambulatoryCard": {
      "title": "Ambulatory Visit Card Review",
      "subtitle": "Small Card | Ambulatory Card",
      "copyEpisodeData": "Copy Data from Another Episode",
      "copyEpisodeModal": {
        "title": "Copy Data from Another Episode",
        "selectEpisode": "Select episode",
        "chooseSections": "Choose data to copy",
        "noEpisodes": "This patient has no other episodes",
        "copyButton": "Copy",
        "backButton": "Back",
        "cancelButton": "Cancel",
        "copiedToast": "Data copied. Review and click Save.",
        "loadError": "Failed to load episode",
        "columns": {
          "date": "Date",
          "ehrNo": "EHR No",
          "doctor": "Doctor"
        },
        "sections": {
          "diagnoses": "Diagnoses",
          "narrative": "Clinical narrative",
          "recommendations": "Recommendations",
          "prescriptions": "Prescriptions (eRx)",
          "insurance": "Insurance / Workplace"
        }
      },
      "printForm100": "Print Form 100",
      "printPrescription": "Print Prescription",
      "printInformedConsent": "Print Informed Consent",
      "smsVerification": "SMS Verification",
      "uploadDocument": "Upload Document",
      "actions": "Actions",
      "comingSoon": "Coming soon",
      "noPrescriptions": "No prescriptions filled",
      "noInformedConsent": "Informed consent not filled",
      "savingInProgress": "Saving the form...",
      "validationError": "Please fill in the required fields",
      "characters": "characters",
      "personalNumberLength": "Personal number must be 11 characters",
      "requiredField": "Required field",
      "sendToEhr": "Send",
      "save": "Save",
      "whereSent": "Where the certificate is sent",
      "form100Number": "Form 100 Number",
      "lastName": "Last Name",
      "firstName": "First Name",
      "fatherName": "Father's Name",
      "episodeNumber": "Episode Number",
      "gender": "Gender",
      "birthDateAge": "Date of Birth / Age",
      "maritalStatus": "Marital Status",
      "disabilityStatus": "Disability Status",
      "personalNumber": "Personal Number",
      "country": "Country",
      "selectCountry": "Select country",
      "city": "City",
      "selectCity": "Select city",
      "placeOfResidence": "Place of Residence",
      "cityDistrict": "City / District",
      "address": "Address",
      "phone": "Phone",
      "employmentStatus": "Employment Status",
      "education": "Education",
      "workplaceProfession": "Workplace, Profession, Position",
      "insuranceCompany": "Insurance Company",
      "fundingSources": "Funding Sources",
      "caseNumber": "Case Number / Pocket Number",
      "patientAdmissionDate": "Patient Admission Date and Time",
      "ambulatoryReferral": "a) Ambulatory Referral",
      "episodeEndDate": "Episode End Date and Time",
      "bloodGroupRh": "Blood Group / Rh Factor",
      "ehrConsent": "I consent to hiding/sharing data on the EHR portal",
      "visibilityStatus": "Hiding/Sharing Status",
      "section9": "9. Conclusion on health condition or full diagnosis (main disease, accompanying diseases, complications)",
      "diagnosisFirstTime": "Diagnosis made for the first time in life",
      "pleaseSelect": "Please select",
      "primaryDiseaseIcd": "Primary Disease / ICD /",
      "selectIcdCode": "Select ICD Code",
      "diagnosisDate": "Diagnosis Date",
      "character": "Character",
      "doctorClarification": "Doctor's Clarification",
      "complicationsIcd": "Primary Disease Complications / ICD /",
      "icdCode": "ICD Code",
      "clarification": "Clarification",
      "accompanyingDiseaseIcd": "Accompanying Disease / ICD /",
      "section10_11": "10. Past Diseases",
      "section10_11_sub": "11. Brief Anamnesis",
      "complaintsIcpc": "Complaints / ICPC /",
      "patientComplainsIcpc": "Patient Complaints / ICPC /",
      "complaintName": "Complaint Name",
      "year": "Year",
      "complaints": "Complaints",
      "anamnesis": "Anamnesis",
      "pastDiseases": "Past Diseases",
      "pregnancyCount": "Number of Pregnancies",
      "deliveryCount": "Number of Deliveries",
      "fillData": "Fill in data",
      "addService": "Add Service",
      "section12": "12. Diagnostic Examinations and Consultations Performed",
      "comment": "Comment",
      "unspecified": "Unspecified",
      "clinicalDiagnosticStudies": "Clinical Diagnostic Studies",
      "labStudies": "Laboratory Studies",
      "surgeries": "Surgeries",
      "consultations": "Consultations",
      "otherActivity": "Other activity",
      "transfusion": "Transfusion",
      "anesthesia": "Anesthesia",
      "operationProtocol": "Operation protocol",
      "prescriptionTreatment": "Prescribed treatment",
      "bloodComponent": "Blood component",
      "protocolNo": "Protocol No.",
      "protocolText": "Protocol text",
      "drug": "Drug",
      "dosage": "Dosage",
      "laboratory": "Laboratory",
      "text": "Text",
      "consultationsTable": "Consultations",
      "specialty": "Specialty",
      "doctor": "Doctor",
      "deleteConfirm": "Delete?",
      "section13": "13. Disease Course",
      "episodeType": "Episode Type",
      "episodeResult": "Episode Result",
      "section14": "14. Treatment Performed",
      "conditionAtReferral": "15. Condition at Referral",
      "selectCondition": "Select Condition",
      "conditionAtDischarge": "16. Condition at Discharge",
      "section17": "17. Recommendation / Prescription",
      "instrumentalStudiesNcsp": "Instrumental Studies / NCSP /",
      "ncspCode": "NCSP Code",
      "date": "Date",
      "labStudiesLab": "Laboratory Studies / LAB /",
      "labCode": "Laboratory Code",
      "consultationsAmbulatory": "Ambulatory Consultations",
      "specialtyField": "Specialty",
      "deadline": "Deadline",
      "otherRecommendations": "Other Recommendations",
      "adviceInstruction": "Advice / Instruction",
      "prescription": "Prescription",
      "uploadToPortal": "Upload to Portal",
      "sent": "Sent",
      "notSent": "Not sent",
      "error": "Error",
      "sending": "Sending...",
      "sendToPortal": "Send to portal",
      "prescriptionSent": "Prescription sent to portal",
      "prescriptionCancelled": "Prescription cancelled on portal",
      "cancelFailed": "Cancel on portal failed",
      "savePrescriptionFirst": "Save the prescription first",
      "addPrescriptionTooltip": "Add prescription",
      "searchMedicineTooltip": "Search for medicine",
      "sendToPortalTooltip": "Send prescription to the e-prescription portal",
      "deletePrescriptionTooltip": "Delete prescription",
      "medicine": "Medicine",
      "search": "Search",
      "tradeForm": "Trade Form",
      "quantity": "Quantity",
      "usageRule": "Usage Instructions",
      "prescriptionValidity": "Validity",
      "prescriptionRecommendation": "Prescription / Recommendation",
      "attendingDoctor": "Attending Doctor (Name)",
      "selectDoctor": "Select Doctor",
      "create": "Create",
      "maritalStatusOptions": {
        "married": "Married",
        "cohabiting": "Cohabiting",
        "single": "Single",
        "divorced": "Divorced",
        "widowed": "Widowed"
      },
      "disabilityOptions": {
        "none": "Not expressed",
        "severe": "Severely expressed",
        "significant": "Significantly expressed",
        "moderate": "Moderately expressed"
      },
      "countryOptions": {
        "georgia": "Georgia",
        "other": "Other"
      },
      "residenceOptions": {
        "city": "City / District",
        "village": "Village"
      },
      "cityOptions": {
        "tbilisi": "Tbilisi",
        "kutaisi": "Kutaisi",
        "batumi": "Batumi"
      },
      "employmentOptions": {
        "employed": "Employed",
        "unemployed": "Unemployed",
        "student": "Student",
        "retired": "Retired",
        "disabled": "Disabled",
        "minor": "Minor",
        "military": "Military",
        "other": "Other"
      },
      "educationOptions": {
        "unknown": "Unknown",
        "primary": "Primary",
        "secondary": "Secondary",
        "higher": "Higher",
        "vocational": "Vocational"
      },
      "fundingOptions": {
        "self": "Self-funded",
        "universal": "Universal Healthcare",
        "private": "Private Insurance"
      },
      "yesNoOptions": {
        "yes": "Yes",
        "no": "No",
        "unknown": "Unknown"
      },
      "isGenericOptions": {
        "onlyGeneric": "Only Generic",
        "genericAndTrade": "Generic and Trade",
        "onlyTrade": "Only Trade"
      }
    },
    "patients": {
      "status": "Status",
      "bookingDate": "Booking Date",
      "user": "User",
      "mobile": "Mobile",
      "employee": "Employee",
      "startTime": "Start Time",
      "endTime": "End Time",
      "service": "Service",
      "room": "Room",
      "personalNumber": "Personal Number",
      "view": "View",
      "ambulatoryCard": "Ambulatory Card",
      "smallAmbulatoryCard": "Small Ambulatory Card"
    },
    "confirmSend": "Are you sure you want to send?"
  },
  "visitComments": {
    "tabTitle": "Comments",
    "noComments": "No comments yet",
    "placeholder": "Write a comment...",
    "selectBooking": "Tag to booking",
    "selectService": "Tag to service",
    "fromDescription": "From description",
    "deleteConfirm": "Delete this comment?",
    "commentsLabel": "comments",
    "pinned": "Pinned",
    "pin": "Pin comment",
    "unpin": "Unpin comment"
  },
  "templateEditor": {
    "insertField": "Insert field",
    "text": "Text",
    "checkbox": "Checkbox",
    "select": "Select",
    "apiSelect": "API Select",
    "signature": "Signature",
    "table": "Table",
    "backToList": "Back to list",
    "templateName": "Template name",
    "importDocx": "Import .docx file",
    "importWord": "Import Word",
    "save": "Save",
    "previewTooltip": "Preview and fill the template",
    "fillPreview": "Fill / Preview",
    "date": "Date",
    "number": "Number",
    "textarea": "Textarea",
    "image": "Image",
    "calculated": "Calculated",
    "autoFill": "Auto-Fill",
    "tooltips": {
      "text": "Insert text input field",
      "checkbox": "Insert checkbox field",
      "select": "Insert dropdown with static options",
      "apiSelect": "Insert dropdown with API-backed options",
      "signature": "Insert signature pad",
      "table": "Insert dynamic table",
      "date": "Insert date picker field",
      "number": "Insert number input field",
      "textarea": "Insert multi-line text field",
      "image": "Insert image/file upload field",
      "calculated": "Insert calculated field",
      "autoFill": "Insert auto-fill data field (patient, doctor, date)"
    }
  },
  "servicePackages": {
    "title": "Service Packages",
    "active": "Active",
    "inactive": "Inactive",
    "days": "days",
    "servicesCount": "services",
    "columns": {
      "name": "Name",
      "price": "Price",
      "validity": "Validity",
      "services": "Services",
      "status": "Status",
      "actions": "Actions"
    },
    "buttons": {
      "purchases": "Purchases",
      "create": "Create",
      "sell": "Sell",
      "cancel": "Cancel",
      "details": "Details"
    },
    "filters": {
      "search": "Search...",
      "status": "Status",
      "all": "All",
      "receivedGifts": "Gifts received",
      "givenGifts": "Given as gifts",
      "ownPurchases": "Own purchases"
    },
    "status": {
      "ACTIVE": "Active",
      "USED": "Used",
      "CANCELLED": "Cancelled",
      "EXPIRED": "Expired"
    },
    "lifecycle": {
      "new": "New",
      "partiallyUsed": "Partially used",
      "fullyUsed": "Fully used",
      "cancelled": "Cancelled",
      "expired": "Expired"
    },
    "form": {
      "createTitle": "Create Package",
      "editTitle": "Edit Package",
      "basicInfo": "Basic Information",
      "name": "Name",
      "namePlaceholder": "Package name",
      "price": "Price",
      "validityDays": "Validity (days)",
      "isActive": "Active",
      "description": "Description",
      "descriptionPlaceholder": "Package description",
      "servicesTitle": "Included Services",
      "addService": "Add Service",
      "noServices": "No services added yet",
      "selectService": "Select service",
      "quantity": "Quantity",
      "originalPrice": "Original Price",
      "discountPercent": "Discount %",
      "discountedPrice": "Discounted Price",
      "totalOriginal": "Total Original",
      "discount": "Discount",
      "packageTotal": "Package price",
      "itemsSum": "Items total",
      "useItemsSum": "Use items total",
      "serviceName": "Service Name"
    },
    "view": {
      "title": "Package Details",
      "details": "Details",
      "includedServices": "Included Services",
      "subtotal": "Subtotal",
      "recentPurchases": "Recent Purchases"
    },
    "purchases": {
      "title": "Purchase History",
      "package": "Package",
      "customer": "Customer",
      "owner": "Owner",
      "status": "Status",
      "lifecycle": "Lifecycle",
      "usage": "Usage",
      "price": "Price",
      "validUntil": "Valid Until",
      "empty": "No purchases found",
      "filterStatus": "Filter by status",
      "filterPackage": "Filter by package",
      "filterCustomer": "Filter by customer",
      "searchPlaceholder": "Search by name or phone",
      "emptyFiltered": "No purchases match your filters",
      "emptyNone": "No purchases yet",
      "editedBadge": "Edited",
      "giftFrom": "Gift from",
      "giftTo": "Gifted to"
    },
    "sellModal": {
      "title": "Sell Package",
      "customer": "Customer",
      "searchCustomer": "Search customer...",
      "paymentMethod": "Payment Method",
      "paidAmount": "Paid Amount",
      "comment": "Comment",
      "commentPlaceholder": "Comment (optional)",
      "paymentSumMismatch": "Payment total must equal the package price"
    },
    "editModal": {
      "displayName": "Display name",
      "validUntil": "Valid until",
      "comment": "Comment",
      "items": "Services",
      "service": "Service",
      "quantity": "Quantity",
      "originalPrice": "Original price",
      "discountedPrice": "Discounted price",
      "consumed": "Consumed",
      "addItem": "Add service",
      "added": "Service added",
      "removed": "Service removed",
      "history": "Edit history",
      "noHistory": "No edit history yet",
      "reason": "Edit reason",
      "reasonText": "Reason details",
      "balanceChange": "Balance change",
      "amountToCollect": "Amount to collect",
      "fullHistory": "Full history",
      "priceRoleDisabled": "Only an administrator or manager can change the price",
      "futureBookingConflictTitle": "Conflict with future bookings",
      "futureBookingConflictBookings": "Bookings",
      "futureBookingConflictConfirm": "Save anyway",
      "settlementBalance": "Balance",
      "settlementCash": "Cash",
      "settlementNone": "No finance operation",
      "chargeCollect": "Collect payment",
      "refundLabel": "Refund",
      "customer": "Customer",
      "customerBalance": "Current balance",
      "settlementCommentPlaceholder": "Note on the refund / payment",
      "saleDate": "Sale date",
      "soldBy": "Sold by",
      "validity": "Validity",
      "totalPaid": "Total paid",
      "payment": "Payment",
      "payCash": "Cash",
      "payCard": "Card",
      "payBalance": "Balance",
      "payBank": "Bank transfer",
      "payConsignation": "Consignation",
      "remaining": "Remaining",
      "totalServices": "Services",
      "totalQuantity": "Total quantity",
      "totalOriginal": "Original total",
      "totalDiscounted": "Discounted total"
    },
    "history": {
      "title": "Package history",
      "when": "Date",
      "kind": "Type",
      "who": "Who",
      "details": "Details",
      "usage": "Usage",
      "kinds": {
        "audit": "Change",
        "adjustment": "Adjustment",
        "usage": "Usage"
      }
    },
    "confirm": {
      "delete": "Are you sure you want to delete this package?",
      "cancel": "Are you sure you want to cancel this purchase?",
      "cancelDescription": "After cancellation, the customer will no longer be able to use remaining services."
    },
    "messages": {
      "loadError": "Failed to load package",
      "created": "Package created successfully",
      "createError": "Failed to create package",
      "updated": "Package updated successfully",
      "updateError": "Failed to update package",
      "deleted": "Package deleted successfully",
      "deleteError": "Failed to delete package",
      "sold": "Package sold successfully",
      "sellError": "Failed to sell package",
      "cancelled": "Purchase cancelled",
      "cancelError": "Failed to cancel purchase",
      "editError": "Failed to edit purchase",
      "refunded": "Refund completed"
    },
    "refund": {
      "used": "Used",
      "typeLabel": "Refund type",
      "type": {
        "full": "Refund full amount",
        "remaining": "Refund remaining value"
      },
      "methodLabel": "Refund method",
      "method": {
        "balance": "To customer balance",
        "none": "Without financial operation",
        "cashbox": "From the cash register"
      },
      "commentLabel": "Reason (optional)",
      "commentPlaceholder": "Enter a refund reason",
      "fullyUsed": "A fully-used package cannot be cancelled",
      "refundable": "Refundable value",
      "moneyBack": "Amount to return",
      "voidedDebt": "Voided debt",
      "confirm": "Confirm refund",
      "settlementLabel": "Settle the refund on",
      "settlement": {
        "today": "Today's cashbox",
        "saleDate": "The sale day's cashbox"
      },
      "settlementHint": "Choose which day the money leaves. If that cashbox is already closed, it will be recalculated."
    }
  },
  "nps": {
    "title": "Feedback",
    "question": "On a scale of 0 to 10, how likely are you to recommend our service to a friend?",
    "notLikely": "Not likely",
    "veryLikely": "Very likely",
    "commentPlaceholder": "Please leave a comment (optional)",
    "submit": "Submit",
    "thankYou": "Thank you for your feedback!",
    "error": "Failed to submit feedback, please try again"
  },
  "EVENT_DESC": {
    "BOOKED": "The client gets a text confirming the booking.",
    "COMPLETED": "The client gets a text after the visit ends.",
    "BOOKING_UPDATE": "The client learns their appointment changed.",
    "BOOKING_DELETED": "The client learns the appointment was cancelled.",
    "BOOKING_REMINDER": "The client gets a reminder before the visit.",
    "PERIODIC_REMINDER": "A past client gets a nudge to book again.",
    "ONLINE_BOOKING_INCOME": "The client gets confirmation of their online booking.",
    "ONLINE_BOOKING_CANCEL": "The client learns their online booking was cancelled.",
    "VERIFICATION_SMS": "The client gets a code and link to verify.",
    "OFFER_EXPIRY_WARNING": "The buyer learns their voucher is about to expire.",
    "OFFER_PURCHASE_CONFIRMATION": "The buyer gets confirmation of the voucher purchase.",
    "OFFER_MERCHANT_NOTIFICATION": "Your team learns a voucher was sold.",
    "PACKAGE_PURCHASE_CONFIRMATION": "The buyer gets confirmation of the package purchase.",
    "PACKAGE_USAGE": "The buyer learns one package service was used.",
    "PACKAGE_BATCH_USAGE": "The buyer learns several package services were used at once.",
    "PACKAGE_EXPIRED": "The buyer learns their package has expired.",
    "PACKAGE_EXPIRY_WARNING": "The buyer learns their package is about to expire.",
    "INVOICE_GENERATED": "The salon gets a text when an invoice is created.",
    "EMPLOYEE_PASSWORD_RESET": "A staff member gets new login details.",
    "USER_PASSWORD_RESET": "A user gets new login details."
  },
  "KEYWORD": {
    "code": "Code",
    "customerName": "Customer name",
    "date": "Date",
    "daysBeforeExpiry": "Days before expiry",
    "expiryDate": "Expiry date",
    "firstName": "First name",
    "invoiceId": "Invoice #",
    "link": "Link",
    "offerName": "Voucher name",
    "organizationName": "Organization",
    "packageName": "Package name",
    "password": "Password",
    "positionName": "Specialist",
    "price": "Price",
    "remaining": "Remaining services",
    "serviceName": "Service",
    "serviceNames": "Services",
    "source": "Source",
    "time": "Time",
    "totalPrice": "Total",
    "username": "Username",
    "validFrom": "Valid from",
    "validTo": "Valid to",
    "validUntil": "Valid until"
  },
  "warehouse": {
    "products": {
      "addProduct/edit": "Add a product/edit",
      "updateHistory": "Update history",
      "updateProduct": "Update product",
      "stockAccounting": "Stock accounting",
      "addProvider/edit": "Add a provider/edit",
      "addEditCategory": "Add/Edit Category",
      "barcodeAlready": "The barcode already exists in the database",
      "title": "Products",
      "column": {
        "barcode": "Barcode",
        "productCode": "Product code",
        "title": "Title",
        "category": "Category",
        "provider": "Provider",
        "quantity": "Quantity",
        "grammInEach": "Gramm in each",
        "receivingPrice": "Receiving price",
        "admissionPrice(average)": "Admission price (average)",
        "salePrice": "Sale price",
        "sumTotal": "Sum total",
        "sumTotal(gram)": "Sum total (gram)",
        "dateOfPurchase": "Date of purchase",
        "validUntil": "Valid until",
        "dateOfUpdate": "Date of update",
        "createdBy": "Created by",
        "comment": "Comment",
        "stockAccounting": "Stock accounting",
        "currentBalance": "Current balance",
        "changeInStock": "Change in stock",
        "created": "Created",
        "legalForm": "Legal form",
        "identification": "Identification #",
        "phoneNumber": "phone number",
        "information": "Information"
      },
      "form": {
        "barcode": "Barcode",
        "productCode": "Product code",
        "title": "Title",
        "category": "Category",
        "provider": "Provider",
        "quantity": "Quantity",
        "grammInEach": "Gramm in each",
        "receivingPrice": "Receiving price",
        "admissionPrice(average)": "Admission price (average)",
        "salePrice": "Sale price",
        "sumTotal": "Sum total",
        "Balance(grams)": "Balance(grams)",
        "dateOfPurchase": "Date of purchase",
        "validUntil": "Valid until",
        "comment": "Comment",
        "averagePrice": "Average price",
        "expenseProcessing": "Expense processing",
        "selectDate": "Select a date",
        "accountingDate": "Accounting date",
        "responsiblePerson": "Responsible person",
        "gram": "gram",
        "productCategory": "Product category",
        "legalForm": "Legal form",
        "identification": "Identification #",
        "phoneNumber": "phone number",
        "information": "Information"
      }
    },
    "categories": {
      "title": "Categories"
    },
    "Providers": {
      "title": "Providers"
    },
    "list": {
      "title": "Warehouses",
      "create": "Create Warehouse"
    },
    "columns": {
      "name": "Name",
      "type": "Type",
      "address": "Address",
      "status": "Status",
      "actions": "Actions"
    },
    "types": {
      "MAIN": "Main",
      "SECONDARY": "Secondary",
      "TRANSIT": "Transit"
    },
    "default": "Default",
    "active": "Active",
    "inactive": "Inactive",
    "setDefault": "Set as default",
    "confirm": {
      "delete": "Are you sure you want to delete this warehouse?"
    },
    "messages": {
      "setDefault": "Warehouse set as default",
      "setDefaultError": "Failed to set warehouse as default",
      "deleted": "Warehouse deleted",
      "deleteError": "Failed to delete warehouse",
      "loadError": "Failed to load warehouse",
      "created": "Warehouse created successfully",
      "createError": "Failed to create warehouse",
      "updated": "Warehouse updated successfully",
      "updateError": "Failed to update warehouse"
    },
    "form": {
      "createTitle": "Create Warehouse",
      "editTitle": "Edit Warehouse",
      "basicInfo": "Basic Information",
      "name": "Name",
      "namePlaceholder": "Warehouse name",
      "type": "Type",
      "typePlaceholder": "Select type",
      "address": "Address",
      "addressPlaceholder": "Warehouse address",
      "description": "Description",
      "descriptionPlaceholder": "Warehouse description",
      "isDefault": "Default warehouse",
      "isActive": "Active"
    },
    "tabs": {
      "stock": "Stock",
      "movements": "Movements"
    },
    "stock": {
      "title": "Stock",
      "selectWarehouse": "Select Warehouse",
      "product": "Product",
      "category": "Category",
      "distributor": "Distributor",
      "quantity": "Quantity",
      "grAmount": "Grams",
      "avgCost": "Avg. Cost",
      "sellPrice": "Sell Price",
      "totalValue": "Total Value",
      "search": "Search products...",
      "viewMovements": "View movements",
      "lowStock": "Low stock"
    },
    "movements": {
      "date": "Date",
      "product": "Product",
      "type": "Type",
      "quantity": "Quantity",
      "balance": "Balance",
      "notes": "Notes"
    },
    "movementTypes": {
      "RECEIVING": "Receiving",
      "SALE_DEDUCTION": "Sale",
      "SALE_RETURN": "Sale Return",
      "TRANSFER_OUT": "Transfer Out",
      "TRANSFER_IN": "Transfer In",
      "ADJUSTMENT": "Adjustment",
      "SERVICE_CONSUMPTION": "Service Consumption",
      "SERVICE_RETURN": "Service Return",
      "COUNT_CORRECTION": "Count Correction",
      "WRITE_OFF": "Write Off",
      "SUPPLIER_RETURN": "Supplier Return",
      "INITIAL_MIGRATION": "Initial Migration"
    },
    "adjustment": {
      "title": "Stock Adjustment",
      "type": "Adjustment Type",
      "newQuantity": "New Quantity",
      "newGrAmount": "New Grams",
      "reason": "Reason",
      "reasonPlaceholder": "Reason for adjustment"
    }
  },
  "realization": {
    "operationCompleted": "The operation is completed",
    "search": {
      "user": "User",
      "realizationType": "Realization type",
      "withBarcode": "Search with barcode",
      "searchProduct": "Search the product"
    },
    "form": {
      "card": "Card #",
      "firstname": "First Name",
      "name": "Name",
      "lastname": "Last Name",
      "phoneNumber": "Phone Number",
      "idNumber": "ID Number",
      "gender": "Gender",
      "female": "Female",
      "male": "Male",
      "dateOfBirth": "Date of Birth",
      "chooseDate": "Choose date",
      "country": "Country",
      "city": "City",
      "address": "Address",
      "workingPlace": "Working Place",
      "createTitle": "Create Warehouse",
      "editTitle": "Edit Warehouse",
      "basicInfo": "Basic Information",
      "namePlaceholder": "Enter warehouse name",
      "type": "Type",
      "typePlaceholder": "Select type",
      "addressPlaceholder": "Enter address",
      "description": "Description",
      "descriptionPlaceholder": "Enter description",
      "isDefault": "Default",
      "isActive": "Active"
    },
    "categoryDetail": {
      "provider": "Provider",
      "price": "price",
      "quantity": "Quantity",
      "grammInEach": "Gramm in each",
      "gramsTotal": "grams total"
    },
    "category": "category",
    "sumTotal": "Sum total",
    "gel": "GEL",
    "quantity": "Quantity",
    "piece": "piece",
    "gram": "gram",
    "paymentMethod": "Payment method",
    "balance": "balance",
    "available": "available",
    "cash": "Cash ",
    "card": "Bank card",
    "exchange": "Exchange",
    "consignment": "Consignment",
    "pay": "Pay",
    "comment": "Comment",
    "specifyComment": "Specify a comment",
    "paymentWithCash": "Cash + via bank",
    "BankCard": "Bank card",
    "cashViaBank": "Cash + via bank",
    "sell": "Sell",
    "spend": "Spend",
    "productOutStock": "The product is out of stock",
    "product": "product",
    "createUser": "Create a user",
    "price": "price",
    "discount": "Discount %",
    "withDiscount": "With a discount",
    "employee": "Employee",
    "addEmployee/edit": "Add an employee/edit",
    "percent": "percent",
    "salary": "Salary",
    "list": {
      "title": "Warehouses",
      "create": "Create Warehouse"
    },
    "columns": {
      "name": "Name",
      "type": "Type",
      "address": "Address",
      "status": "Status",
      "actions": "Actions"
    },
    "types": {
      "MAIN": "Main",
      "SECONDARY": "Secondary",
      "TRANSIT": "Transit"
    },
    "default": "Default",
    "active": "Active",
    "inactive": "Inactive",
    "setDefault": "Set as Default",
    "confirm": {
      "delete": "Are you sure you want to delete this warehouse?"
    },
    "messages": {
      "created": "Warehouse created successfully",
      "updated": "Warehouse updated successfully",
      "deleted": "Warehouse deleted successfully",
      "setDefault": "Default warehouse updated",
      "loadError": "Failed to load warehouse",
      "createError": "Failed to create warehouse",
      "updateError": "Failed to update warehouse",
      "deleteError": "Failed to delete warehouse",
      "setDefaultError": "Failed to set default warehouse"
    },
    "tabs": {
      "stock": "Stock",
      "movements": "Movements"
    },
    "stock": {
      "title": "Stock",
      "selectWarehouse": "Select Warehouse",
      "search": "Search product...",
      "product": "Product",
      "category": "Category",
      "distributor": "Distributor",
      "quantity": "Qty",
      "grAmount": "Grams",
      "avgCost": "Avg Cost",
      "sellPrice": "Sell Price",
      "totalValue": "Total Value",
      "viewMovements": "View Movements",
      "lowStock": "Low Stock"
    },
    "movements": {
      "title": "Stock Movements",
      "date": "Date",
      "product": "Product",
      "type": "Type",
      "quantity": "Quantity",
      "grAmount": "Grams",
      "balance": "Balance",
      "unitCost": "Unit Cost",
      "reference": "Reference",
      "performer": "Performed By",
      "notes": "Notes"
    },
    "movementTypes": {
      "RECEIVING": "Receiving",
      "SALE_DEDUCTION": "Sale",
      "SALE_RETURN": "Sale Return",
      "TRANSFER_OUT": "Transfer Out",
      "TRANSFER_IN": "Transfer In",
      "ADJUSTMENT": "Adjustment",
      "SERVICE_CONSUMPTION": "Service Consumption",
      "SERVICE_RETURN": "Service Return",
      "COUNT_CORRECTION": "Count Correction",
      "INITIAL_MIGRATION": "Initial Migration",
      "WRITE_OFF": "Write-Off",
      "SUPPLIER_RETURN": "Supplier Return"
    },
    "adjustment": {
      "title": "Stock Adjustment",
      "product": "Product",
      "currentQty": "Current Quantity",
      "currentGr": "Current Grams",
      "type": "Adjustment Type",
      "newQty": "New Quantity",
      "newGr": "New Grams",
      "reason": "Reason",
      "reasonPlaceholder": "Enter reason for adjustment",
      "types": {
        "COUNT": "Count",
        "DAMAGE": "Damage",
        "LOSS": "Loss",
        "EXPIRY": "Expiry",
        "RETURN": "Return",
        "OTHER": "Other"
      }
    }
  },
  "schedule": {
    "vacationRange": "Vacation (range)",
    "vacationApply": "Add",
    "vacationConflict": "{{count}} conflict(s) in the range. Proceed anyway?",
    "vacationSaved": "Vacation added",
    "vacationPickRange": "Select a period",
    "clearAll": "Clear schedule",
    "clearConfirmTitle": "Are you sure you want to fully clear the employee's work schedule?",
    "clearConfirmBody": "The employee's entire work schedule will be deleted.",
    "clearWarnBookings": "Warning: the employee has {{count}} booked visit(s) that would be left without a schedule.",
    "cleared": "Schedule cleared",
    "clearWhat": "What to clear?",
    "clearFromToday": "Clears from today onward (past is kept)",
    "clearWillRemove": "{{count}} entries will be removed",
    "leaveType": "Type",
    "period": "Period",
    "conflictTitle": "Conflicts found in the range",
    "conflictBookings": "Bookings",
    "conflictLeave": "Existing time-off",
    "conflictProceed": "Continue anyway?",
    "startDate": "Start date",
    "endDate": "End date",
    "applyOn": "Apply on",
    "workingHours": "Working hours",
    "perDayHours": "Per-day hours (optional)",
    "addBreak": "Add break",
    "breaksAllDays": "Breaks (all days)",
    "save": "Save",
    "endAfterStart": "End must be after start",
    "statusLabel": "Status",
    "statusRequired": "Status is required",
    "weekday": {
      "0": "Sun",
      "1": "Mon",
      "2": "Tue",
      "3": "Wed",
      "4": "Thu",
      "5": "Fri",
      "6": "Sat"
    },
    "break": {
      "LUNCH": "Lunch",
      "COFFEE": "Coffee",
      "PERSONAL": "Personal"
    },
    "createSchedule": "Create schedule",
    "addVacation": "Add vacation",
    "addDay": "Add day",
    "logs": "History",
    "cancel": "Cancel",
    "multiTitle": "Multi-day schedule",
    "editDay": "Edit day",
    "auditTitle": "Change history",
    "status": {
      "SCHEDULED": "Scheduled",
      "DAY_OFF": "Day off",
      "SICK_LEAVE": "Sick leave",
      "VACATION": "Vacation"
    }
  },
  "scheduleOverview": {
    "title": "Employees schedule",
    "employee": "Employee",
    "searchPlaceholder": "Search by name",
    "positionAll": "All positions",
    "today": "Today",
    "oneMonth": "1 month",
    "nMonths": "{{count}} months",
    "unscheduledDivider": "No schedule",
    "unscheduledCount": "{{count}} employees with no schedule",
    "rowActions": "Row actions",
    "rowActionHours": "Set working hours (range)",
    "rowActionLeave": "Add leave",
    "rowActionClear": "Clear schedule",
    "noEmployees": "No employees match",
    "error": "Could not load the schedule",
    "retry": "Retry"
  },
  "procedures": {
    "hub": {
      "overview": "Overview",
      "employees": "Employees",
      "category": "Category",
      "colour": "Colour",
      "type": "Type",
      "price": "Price",
      "discountPrice": "Discount price",
      "duration": "Duration",
      "vat": "VAT",
      "maxParallel": "Max parallel bookings",
      "onlineBooking": "Online booking",
      "boundEmployees": "Bound employees",
      "missingParameters": "Conflicting salary term",
      "selectAll": "Select All",
      "percent": "%",
      "noParameters": "No parameters set",
      "saved": "Saved",
      "saveFailed": "Save failed",
      "fillAllFields": "For the selected employees fill price, duration and one salary term — percent or fixed, not both.",
      "save": "Save",
      "loadProcedureFailed": "Failed to load the procedure details.",
      "loadEmployeesFailed": "Failed to load employees.",
      "loadBindingsFailed": "Failed to load employee parameters.",
      "noneSelected": "Select at least one employee before saving.",
      "futureBookings": "{{count}} upcoming",
      "willUnbind": "{{count}} employee(s) will be removed",
      "confirmUnbindTitle": "Remove employees",
      "confirmUnbindOk": "Remove",
      "confirmUnbindCancel": "Cancel",
      "confirmUnbindNote": "Existing bookings are not deleted. This procedure will no longer be offered for these employees in new bookings.",
      "fixedSalary": "Fixed",
      "searchEmployee": "Search employee",
      "defaultsLegend": "Values in grey are the defaults. Click one to set something different for this employee.",
      "useDefault": "Use the default",
      "overrideHint": "Click to set a different value for this employee",
      "addEmployee": "Add an employee",
      "noEmployeesYet": "No employees on this service yet.",
      "sharedParams": "Shared parameters",
      "applyToSelected": "Apply to selected",
      "sharedApplied": "Parameters applied to {{count}} employees",
      "addAll": "Add all",
      "allAdded": "{{count}} employees added"
    }
  },
  "employee360": {
    "tab": "360",
    "loadFailed": "Could not load the data",
    "retry": "Retry",
    "scheduledDays": "Worked days",
    "custom": {
      "from": "From",
      "to": "To"
    },
    "period": {
      "TODAY": "Today",
      "YESTERDAY": "Yesterday",
      "THIS_WEEK": "This week",
      "LAST_WEEK": "Last week",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "THIS_YEAR": "This year",
      "CUSTOM": "Period"
    },
    "kpi": {
      "revenue": "Revenue generated",
      "cost": "Salary accrued",
      "netProfit": "Profit",
      "margin": "Profit margin",
      "serviceEarned": "Earned from services",
      "productEarned": "Earned from products",
      "salaryPaid": "Salary paid",
      "revenuePerWorkedDay": "Average revenue per worked day"
    },
    "countUnit": {
      "visits": "Visits",
      "bookings": "Bookings",
      "services": "Services"
    },
    "counts": {
      "total": "Total",
      "completed": "Completed",
      "upcoming": "To perform",
      "cancelled": "Cancelled",
      "noShow": "No-show"
    },
    "hourlyLoad": "Hourly load",
    "topServices": "Top services",
    "topServicesColumns": {
      "name": "Name",
      "count": "Count",
      "revenue": "Revenue"
    },
    "noData": "No data available"
  },
  "visit": {
    "missing": {
      "customer": "Choose a customer",
      "date": "Choose a date",
      "startTime": "Choose a start time",
      "endTime": "Choose an end time",
      "unknown": "Every required field must be filled in before the visit can be saved"
    }
  }
}
